var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/components/page/page/Page.tsx
import { clsx } from "clsx";
import { jsx } from "react/jsx-runtime";
var Page = (_a) => {
  var _b = _a, { children, className } = _b, props = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */ jsx("main", __spreadProps(__spreadValues({ className: clsx("bg-semantic-global-background-light-grey flex h-screen w-full flex-col", className) }, props), { children: /* @__PURE__ */ jsx("div", { className: "gap-semantic-global-lg pb-semantic-global-lg flex w-full flex-col items-center", children }) }));
};

// src/components/page/header/Header.tsx
import { clsx as clsx2 } from "clsx";
import { Fragment, jsx as jsx2, jsxs } from "react/jsx-runtime";
var PageHeader = (_a) => {
  var _b = _a, { background = "white", children, className, sticky = false } = _b, props = __objRest(_b, ["background", "children", "className", "sticky"]);
  const backgroundClass = background === "dark-blue" ? "bg-semantic-global-primary-darkest" : background === "light-grey" ? "bg-semantic-global-background-light-grey" : "bg-semantic-global-background-white";
  const sharedHeaderClassName = clsx2("flex w-full justify-center px-semantic-global-md md:px-semantic-global-lg xl:px-0", className);
  if (sticky) {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx2(
        "header",
        __spreadProps(__spreadValues({
          id: "page-header",
          className: clsx2(backgroundClass, "z-index-dialog fixed top-0 right-0 left-0 hidden lg:flex", sharedHeaderClassName)
        }, props), {
          children
        })
      ),
      /* @__PURE__ */ jsx2("header", { "aria-hidden": true, className: clsx2("bg-semantic-global-background-white top-0 text-white", sharedHeaderClassName), children })
    ] });
  }
  return /* @__PURE__ */ jsx2("header", __spreadProps(__spreadValues({ id: "page-header", className: clsx2(backgroundClass, sharedHeaderClassName) }, props), { children }));
};

// src/components/page/app-header/AppHeader.tsx
import { clsx as clsx3 } from "clsx";

// src/components/page/debug.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var debugColors = {
  appHeader: "#ef4444",
  appTitle: "#14b8a6",
  aside: "#a855f7",
  page: "#3b82f6",
  pageContent: "#22c55e",
  pageHeader: "#eab308",
  pageSubHeader: "#f97316"
};
var debugOutlineStyle = (color) => ({
  outline: `2px dashed ${color}`,
  outlineOffset: "-2px"
});
var debugStyle = (color) => ({
  outline: `2px dashed ${color}`,
  outlineOffset: "-2px",
  position: "relative"
});
var DebugLabel = ({ color, name }) => /* @__PURE__ */ jsx3(
  "span",
  {
    "aria-hidden": true,
    style: {
      alignItems: "center",
      display: "flex",
      inset: 0,
      justifyContent: "center",
      pointerEvents: "none",
      position: "absolute",
      userSelect: "none",
      zIndex: 9999
    },
    children: /* @__PURE__ */ jsx3(
      "span",
      {
        style: {
          background: color,
          borderRadius: "3px",
          color: "#fff",
          fontFamily: "monospace",
          fontSize: "10px",
          fontWeight: "bold",
          lineHeight: "16px",
          padding: "1px 5px"
        },
        children: name
      }
    )
  }
);

// src/components/page/app-header/AppHeader.tsx
import { Fragment as Fragment2, jsx as jsx4, jsxs as jsxs2 } from "react/jsx-runtime";
var AppHeader = (_a) => {
  var _b = _a, {
    background = "white",
    children,
    className,
    debug: debugProp,
    sticky = false
  } = _b, props = __objRest(_b, [
    "background",
    "children",
    "className",
    "debug",
    "sticky"
  ]);
  const debug = debugProp != null ? debugProp : false;
  const color = debugColors.appHeader;
  const backgroundClass = background === "dark-blue" ? "bg-semantic-global-primary-darkest" : background === "light-grey" ? "bg-semantic-global-background-light-grey" : "bg-semantic-global-background-white";
  const sharedClassName = clsx3("flex w-full justify-center h-[62px] px-semantic-global-md md:px-semantic-global-lg", className);
  if (sticky) {
    return /* @__PURE__ */ jsxs2(Fragment2, { children: [
      /* @__PURE__ */ jsx4(
        "header",
        __spreadProps(__spreadValues({
          id: "app-header",
          className: clsx3("bg-semantic-global-primary-darkest fixed top-0 right-0 bottom-0 left-0 z-50 hidden lg:flex", sharedClassName),
          style: debug ? debugOutlineStyle(color) : void 0
        }, props), {
          children
        })
      ),
      /* @__PURE__ */ jsx4("header", { "aria-hidden": true, className: clsx3("bg-semantic-global-background-white top-0 text-white", sharedClassName), children })
    ] });
  }
  return /* @__PURE__ */ jsx4("header", __spreadProps(__spreadValues({ id: "app-header", className: clsx3(backgroundClass, sharedClassName), style: debug ? debugStyle(color) : void 0 }, props), { children }));
};

// src/components/page/app-main/AppMain.tsx
import { clsx as clsx4 } from "clsx";
import { jsx as jsx5, jsxs as jsxs3 } from "react/jsx-runtime";
var AppMain = (_a) => {
  var _b = _a, {
    aside,
    asideVariant = "fixed",
    children,
    className,
    debug: debugProp,
    disableMobilePaddingX = false,
    stickyFooter
  } = _b, props = __objRest(_b, [
    "aside",
    "asideVariant",
    "children",
    "className",
    "debug",
    "disableMobilePaddingX",
    "stickyFooter"
  ]);
  const debug = debugProp != null ? debugProp : false;
  return /* @__PURE__ */ jsx5(
    "main",
    __spreadProps(__spreadValues({
      className: clsx4("bg-semantic-global-background-light-grey lg:pl-semantic-global-xl flex h-screen w-full flex-col xl:pl-0", className),
      style: debug ? debugStyle(debugColors.page) : void 0
    }, props), {
      children: /* @__PURE__ */ jsxs3("div", { className: "flex min-h-0 flex-1 flex-col", children: [
        aside ? /* @__PURE__ */ jsxs3("div", { className: clsx4("gap-x-semantic-global-xl mx-auto w-full max-w-7xl flex-1 lg:flex 2xl:max-w-352"), children: [
          /* @__PURE__ */ jsx5(
            "div",
            {
              className: clsx4(
                "mb-semantic-global-md md:mb-semantic-global-lg flex min-w-0 flex-1 flex-col",
                !disableMobilePaddingX && "px-semantic-global-md pt-semantic-global-md lg:px-0 lg:pt-0"
              ),
              children
            }
          ),
          /* @__PURE__ */ jsxs3("aside", { className: "hidden w-83.5 shrink-0 items-start lg:flex xl:w-90", style: debug ? debugStyle(debugColors.aside) : void 0, children: [
            debug ? /* @__PURE__ */ jsx5(DebugLabel, { name: "aside", color: debugColors.aside }) : null,
            /* @__PURE__ */ jsx5(
              "div",
              {
                className: clsx4(
                  "flex w-83.5 justify-center xl:w-90",
                  asideVariant === "sticky" ? "sticky top-15.5 items-start self-start" : "fixed top-0 h-screen items-center"
                ),
                children: aside
              }
            )
          ] })
        ] }) : /* @__PURE__ */ jsx5(
          "div",
          {
            className: clsx4(
              "mb-semantic-global-lg flex w-full flex-col items-center",
              !disableMobilePaddingX && "px-semantic-global-md pt-semantic-global-md lg:px-0 lg:pt-0"
            ),
            children
          }
        ),
        stickyFooter ? /* @__PURE__ */ jsx5("div", { className: "border-semantic-global-border-light bg-semantic-global-background-white sticky bottom-0 z-10 border-t lg:hidden", children: stickyFooter }) : null
      ] })
    })
  );
};

// src/components/page/app-content/AppContent.tsx
import { clsx as clsx5 } from "clsx";
import { jsx as jsx6, jsxs as jsxs4 } from "react/jsx-runtime";
var AppContent = (_a) => {
  var _b = _a, { background = "transparent", children, className, debug: debugProp } = _b, props = __objRest(_b, ["background", "children", "className", "debug"]);
  const debug = debugProp != null ? debugProp : false;
  const color = debugColors.pageContent;
  const backgroundClass = background === "white" ? "bg-semantic-global-background-white" : void 0;
  return /* @__PURE__ */ jsxs4(
    "section",
    __spreadProps(__spreadValues({
      className: clsx5("flex min-w-0 flex-1 flex-col", backgroundClass, className),
      style: debug ? debugStyle(color) : void 0
    }, props), {
      children: [
        debug ? /* @__PURE__ */ jsx6(DebugLabel, { name: "section", color }) : null,
        children
      ]
    })
  );
};

// src/components/page/app-nav/AppNav.tsx
import { clsx as clsx6 } from "clsx";
import { jsx as jsx7 } from "react/jsx-runtime";
var AppNav = (_a) => {
  var _b = _a, { background = "white", children, className, debug: debugProp } = _b, props = __objRest(_b, ["background", "children", "className", "debug"]);
  const debug = debugProp != null ? debugProp : false;
  const color = debugColors.pageHeader;
  const backgroundClass = background === "dark-blue" ? "bg-semantic-global-primary-darkest" : background === "light-grey" ? "bg-semantic-global-background-light-grey" : "bg-semantic-global-background-white";
  const sharedHeaderClassName = clsx6(
    "flex w-full justify-center py-semantic-global-lg px-semantic-global-md md:px-semantic-global-lg xl:px-0",
    className
  );
  return /* @__PURE__ */ jsx7("nav", __spreadProps(__spreadValues({ id: "page-nav", className: clsx6(backgroundClass, sharedHeaderClassName), style: debug ? debugStyle(color) : void 0 }, props), { children }));
};

// src/components/page/section/Section.tsx
import { clsx as clsx7 } from "clsx";
import { jsx as jsx8, jsxs as jsxs5 } from "react/jsx-runtime";
var Section = (_a) => {
  var _b = _a, { children, className, disablePaddings, sidebar, sticky = false } = _b, props = __objRest(_b, ["children", "className", "disablePaddings", "sidebar", "sticky"]);
  return /* @__PURE__ */ jsxs5(
    "div",
    __spreadProps(__spreadValues({
      className: clsx7(
        "gap-x-semantic-global-xl w-full max-w-7xl md:px-0 lg:flex 2xl:max-w-352",
        disablePaddings ? "px-0" : "px-semantic-global-md md:px-0",
        className
      )
    }, props), {
      children: [
        /* @__PURE__ */ jsx8("section", { id: "section", className: clsx7("gap-semantic-global-lg flex flex-col", sidebar ? "min-w-0 flex-1" : "w-full"), children }),
        sidebar ? /* @__PURE__ */ jsx8("section", { className: "hidden w-83.5 shrink-0 items-start lg:flex xl:w-90", children: /* @__PURE__ */ jsx8(
          "div",
          {
            className: clsx7(
              "flex w-83.5 justify-center xl:w-90",
              sticky ? "sticky top-15.5 items-start self-start" : "fixed top-0 h-screen items-center"
            ),
            children: sidebar
          }
        ) }) : null
      ]
    })
  );
};

// src/components/cards/DesktopCard.tsx
import { clsx as clsx11 } from "clsx";

// src/components/atoms/accordion/Accordion.tsx
import { clsx as clsx8 } from "clsx";
import { ChevronDownIcon } from "@dfds-frontend/navigator-icons/icons";
import { jsx as jsx9, jsxs as jsxs6 } from "react/jsx-runtime";
var Accordion = ({ attr, children, title }) => {
  return /* @__PURE__ */ jsxs6("details", { className: "group", "data-e2e": attr != null ? attr : "accordion", children: [
    /* @__PURE__ */ jsxs6("summary", { className: "text-semantic-global-primary-default hover:text-semantic-global-primary-dark active:text-semantic-global-primary-darker font-primitive-dfds-sans font-primitive-medium tracking-primitive-0 inline-flex w-fit cursor-pointer list-none items-center gap-1 py-1 [&::-webkit-details-marker]:hidden", children: [
      title,
      /* @__PURE__ */ jsx9(ChevronDownIcon, { className: clsx8("transition-transform duration-200 group-open:rotate-180"), size: "md" })
    ] }),
    /* @__PURE__ */ jsx9("div", { className: "pt-semantic-global-sm", children })
  ] });
};

// ../../node_modules/.pnpm/class-variance-authority@0.7.1/node_modules/class-variance-authority/dist/index.mjs
import { clsx as clsx9 } from "clsx";
var falsyToString = (value) => typeof value === "boolean" ? `${value}` : value === 0 ? "0" : value;
var cx = clsx9;
var cva = (base, config) => (props) => {
  var _config_compoundVariants;
  if ((config === null || config === void 0 ? void 0 : config.variants) == null) return cx(base, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
  const { variants, defaultVariants } = config;
  const getVariantClassNames = Object.keys(variants).map((variant) => {
    const variantProp = props === null || props === void 0 ? void 0 : props[variant];
    const defaultVariantProp = defaultVariants === null || defaultVariants === void 0 ? void 0 : defaultVariants[variant];
    if (variantProp === null) return null;
    const variantKey = falsyToString(variantProp) || falsyToString(defaultVariantProp);
    return variants[variant][variantKey];
  });
  const propsWithoutUndefined = props && Object.entries(props).reduce((acc, param) => {
    let [key, value] = param;
    if (value === void 0) {
      return acc;
    }
    acc[key] = value;
    return acc;
  }, {});
  const getCompoundVariantClassNames = config === null || config === void 0 ? void 0 : (_config_compoundVariants = config.compoundVariants) === null || _config_compoundVariants === void 0 ? void 0 : _config_compoundVariants.reduce((acc, param) => {
    let _a = param, { class: cvClass, className: cvClassName } = _a, compoundVariantOptions = __objRest(_a, ["class", "className"]);
    return Object.entries(compoundVariantOptions).every((param2) => {
      let [key, value] = param2;
      return Array.isArray(value) ? value.includes(__spreadValues(__spreadValues({}, defaultVariants), propsWithoutUndefined)[key]) : __spreadValues(__spreadValues({}, defaultVariants), propsWithoutUndefined)[key] === value;
    }) ? [
      ...acc,
      cvClass,
      cvClassName
    ] : acc;
  }, []);
  return cx(base, getVariantClassNames, getCompoundVariantClassNames, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
};

// src/components/atoms/image-container/ImageContainer.tsx
import { clsx as clsx10 } from "clsx";

// src/components/atoms/image-container/fallback.svg
var fallback_default = 'data:image/svg+xml,<svg width="537" height="302" viewBox="0 0 537 302" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<rect width="537" height="302" fill="%23D1EBFF"/>%0A<path d="M230 182C227.791 182 226 180.209 226 178V126.374C226 124.683 226.672 123.062 227.867 121.867C229.063 120.672 230.684 120 232.375 120H304.625C306.316 120 307.937 120.672 309.133 121.867C310.328 123.062 311 124.683 311 126.374V178C311 180.209 309.209 182 307 182H230ZM304.625 141.246V126.374H232.375V162.492H236.625C270.831 162.492 267.11 141.752 304.625 141.25V141.246Z" fill="%231A63F5"/>%0A</svg>%0A';

// src/components/atoms/image-container/ImageContainer.tsx
import { jsx as jsx10 } from "react/jsx-runtime";
var imageContainerVariants = cva("relative", {
  defaultVariants: {
    aspectRatio: "16:9",
    objectStyle: "fit"
  },
  variants: {
    aspectRatio: {
      "2:1": "aspect-2/1",
      "4:3": "aspect-4/3",
      "16:9": "aspect-video"
    },
    objectStyle: {
      fill: "object-cover",
      fit: "object-contain"
    }
  }
});
var ImageContainer = (_a) => {
  var _b = _a, {
    alt,
    as,
    aspectRatio = "16:9",
    className,
    decorative,
    fallbackSrc = fallback_default,
    objectStyle = "fit",
    src
  } = _b, props = __objRest(_b, [
    "alt",
    "as",
    "aspectRatio",
    "className",
    "decorative",
    "fallbackSrc",
    "objectStyle",
    "src"
  ]);
  const Component = as != null ? as : "img";
  const isUsingFallback = !src;
  const treatAsDecorative = decorative || isUsingFallback;
  return /* @__PURE__ */ jsx10(
    Component,
    __spreadProps(__spreadValues({}, props), {
      alt: treatAsDecorative ? "" : alt,
      className: clsx10(imageContainerVariants({ aspectRatio, objectStyle }), className),
      role: treatAsDecorative ? "presentation" : void 0,
      src: src != null ? src : fallbackSrc
    })
  );
};
ImageContainer.displayName = "ImageContainer";

// src/components/cards/DesktopCard.tsx
import { Fragment as Fragment3, jsx as jsx11, jsxs as jsxs7 } from "react/jsx-runtime";
var CardPrice = ({ assistiveText, price }) => {
  return /* @__PURE__ */ jsxs7("div", { className: "gap-semantic-global-3xs mt-auto flex flex-col", children: [
    /* @__PURE__ */ jsx11("span", { className: "typography-body-md-medium text-semantic-global-text-default", children: price }),
    assistiveText ? /* @__PURE__ */ jsx11("span", { className: "typography-body-sm-regular text-semantic-global-text-light", children: assistiveText }) : null
  ] });
};
var DesktopCard = (_a) => {
  var _b = _a, {
    badge,
    children,
    className,
    description,
    details,
    detailsTitle,
    imageAlt,
    imageSrc,
    price,
    priceAssistiveText,
    soldout = false,
    soldoutTitle = "Sold Out",
    title
  } = _b, props = __objRest(_b, [
    "badge",
    "children",
    "className",
    "description",
    "details",
    "detailsTitle",
    "imageAlt",
    "imageSrc",
    "price",
    "priceAssistiveText",
    "soldout",
    "soldoutTitle",
    "title"
  ]);
  return /* @__PURE__ */ jsxs7(
    "div",
    __spreadProps(__spreadValues({
      className: clsx11(
        "gap-semantic-global-lg border-semantic-global-neutral-lighter bg-semantic-global-background-white p-semantic-global-lg flex items-stretch justify-between border",
        className
      )
    }, props), {
      children: [
        /* @__PURE__ */ jsxs7("div", { className: "gap-semantic-global-md flex min-w-0 flex-1 flex-col", children: [
          /* @__PURE__ */ jsxs7("div", { className: "gap-semantic-global-sm flex flex-col", children: [
            /* @__PURE__ */ jsxs7("div", { className: "gap-semantic-global-xs flex items-center", children: [
              /* @__PURE__ */ jsx11(
                "h3",
                {
                  className: clsx11(
                    "typography-heading-md",
                    soldout ? "text-semantic-global-disabled-dark" : "text-semantic-global-text-default"
                  ),
                  children: title
                }
              ),
              badge ? badge : null
            ] }),
            /* @__PURE__ */ jsx11(
              "p",
              {
                className: clsx11(
                  "typography-body-md-regular",
                  soldout ? "text-semantic-global-disabled-default" : "text-semantic-global-text-default"
                ),
                children: description
              }
            )
          ] }),
          !soldout && details ? /* @__PURE__ */ jsx11(Accordion, { attr: "view-details-desktop", title: detailsTitle != null ? detailsTitle : "", children: details }) : null,
          /* @__PURE__ */ jsx11("div", { className: "gap-semantic-global-md mt-auto flex items-center justify-between", children: soldout ? /* @__PURE__ */ jsx11("div", { className: "typography-heading-md text-semantic-global-disabled-default", children: soldoutTitle }) : /* @__PURE__ */ jsxs7(Fragment3, { children: [
            /* @__PURE__ */ jsx11(CardPrice, { assistiveText: priceAssistiveText, price }),
            /* @__PURE__ */ jsx11("div", { className: "mt-auto shrink-0", children })
          ] }) })
        ] }),
        /* @__PURE__ */ jsx11("div", { className: "w-55 shrink-0 self-start", children: /* @__PURE__ */ jsx11(ImageContainer, { alt: imageAlt != null ? imageAlt : title, aspectRatio: "4:3", className: "h-full w-full", objectStyle: "fill", src: imageSrc }) })
      ]
    })
  );
};

// src/components/cards/MobileCard.tsx
import { clsx as clsx13 } from "clsx";

// src/components/atoms/seperator/Seperator.tsx
import { clsx as clsx12 } from "clsx";
import { jsx as jsx12 } from "react/jsx-runtime";
var seperatorVariants = cva("", {
  compoundVariants: [
    {
      className: "bg-semantic-global-neutral-lighter",
      orientation: "vertical",
      variant: "low"
    },
    {
      className: "bg-semantic-global-neutral-dark",
      orientation: "vertical",
      variant: "medium"
    },
    {
      asHr: false,
      className: "bg-semantic-global-neutral-lighter",
      orientation: "horizontal",
      variant: "low"
    },
    {
      asHr: false,
      className: "bg-semantic-global-neutral-dark",
      orientation: "horizontal",
      variant: "medium"
    },
    {
      asHr: true,
      className: "h-0 border-0 border-t border-semantic-global-neutral-lighter",
      orientation: "horizontal",
      variant: "low"
    },
    {
      asHr: true,
      className: "h-0 border-0 border-t border-semantic-global-neutral-dark",
      orientation: "horizontal",
      variant: "medium"
    }
  ],
  defaultVariants: {
    asHr: false,
    orientation: "horizontal",
    variant: "low"
  },
  variants: {
    asHr: {
      false: "",
      true: ""
    },
    orientation: {
      horizontal: "h-px w-full",
      vertical: "h-full w-px"
    },
    variant: {
      low: "",
      medium: ""
    }
  }
});
var Seperator = (_a) => {
  var _b = _a, { asHr = false, className, orientation = "horizontal", variant = "low" } = _b, props = __objRest(_b, ["asHr", "className", "orientation", "variant"]);
  const Component = asHr ? "hr" : "div";
  return /* @__PURE__ */ jsx12(
    Component,
    __spreadValues({
      "aria-orientation": orientation,
      className: clsx12(seperatorVariants({ asHr, orientation, variant }), className),
      role: "separator"
    }, props)
  );
};

// src/components/cards/MobileCard.tsx
import { Fragment as Fragment4, jsx as jsx13, jsxs as jsxs8 } from "react/jsx-runtime";
var CardPrice2 = ({ assistiveText, price }) => {
  return /* @__PURE__ */ jsxs8("div", { className: "gap-semantic-global-3xs flex flex-col", children: [
    /* @__PURE__ */ jsx13("span", { className: "typography-body-md-medium text-semantic-global-text-default", children: price }),
    assistiveText ? /* @__PURE__ */ jsx13("span", { className: "typography-body-sm-regular text-semantic-global-text-light", children: assistiveText }) : null
  ] });
};
var MobileCard = (_a) => {
  var _b = _a, {
    badge,
    children,
    className,
    description,
    details,
    detailsTitle,
    imageAlt,
    imageSrc,
    price,
    priceAssistiveText,
    soldout = false,
    soldoutTitle = "Sold Out",
    title
  } = _b, props = __objRest(_b, [
    "badge",
    "children",
    "className",
    "description",
    "details",
    "detailsTitle",
    "imageAlt",
    "imageSrc",
    "price",
    "priceAssistiveText",
    "soldout",
    "soldoutTitle",
    "title"
  ]);
  return /* @__PURE__ */ jsxs8(
    "div",
    __spreadProps(__spreadValues({
      className: clsx13(
        "gap-semantic-global-md border-semantic-global-neutral-lighter bg-semantic-global-background-white p-semantic-global-md flex flex-col border",
        className
      )
    }, props), {
      children: [
        /* @__PURE__ */ jsxs8("div", { className: "gap-semantic-global-sm flex items-start justify-between", children: [
          /* @__PURE__ */ jsxs8("div", { className: "gap-semantic-global-sm flex min-w-0 flex-1 flex-col", children: [
            /* @__PURE__ */ jsx13(
              "h3",
              {
                className: clsx13("typography-heading-md", soldout ? "text-semantic-global-disabled-dark" : "text-semantic-global-text-default"),
                children: title
              }
            ),
            badge ? /* @__PURE__ */ jsx13("div", { children: badge }) : null
          ] }),
          /* @__PURE__ */ jsx13("div", { className: "w-24 shrink-0", children: /* @__PURE__ */ jsx13(ImageContainer, { alt: imageAlt != null ? imageAlt : title, aspectRatio: "4:3", className: "h-full w-full", objectStyle: "fill", src: imageSrc }) })
        ] }),
        /* @__PURE__ */ jsx13("div", { children: /* @__PURE__ */ jsx13(
          "p",
          {
            className: clsx13(
              "typography-body-md-regular",
              soldout ? "text-semantic-global-disabled-default" : "text-semantic-global-text-default"
            ),
            children: description
          }
        ) }),
        !soldout && details ? /* @__PURE__ */ jsx13(Accordion, { attr: "view-details-mobile", title: detailsTitle != null ? detailsTitle : "", children: details }) : null,
        /* @__PURE__ */ jsx13(Seperator, { orientation: "horizontal", variant: "low" }),
        /* @__PURE__ */ jsx13("div", { className: "gap-semantic-global-md flex flex-row items-center justify-between", children: soldout ? /* @__PURE__ */ jsx13("div", { className: "typography-heading-md text-semantic-global-disabled-default", children: soldoutTitle }) : /* @__PURE__ */ jsxs8(Fragment4, { children: [
          /* @__PURE__ */ jsx13(CardPrice2, { assistiveText: priceAssistiveText, price }),
          /* @__PURE__ */ jsx13("div", { className: "shrink-0", children })
        ] }) })
      ]
    })
  );
};

// src/components/confirmation/passengers-details/PassengersDetails.tsx
import { PassengerIcon, ChildIcon, InfantIcon } from "@dfds-frontend/navigator-icons/icons";
import { jsx as jsx14, jsxs as jsxs9 } from "react/jsx-runtime";
var PassengersDetails = ({ categories }) => {
  const getCategoryIcon = (type) => {
    if (type === "ADULT") return PassengerIcon;
    if (type === "CHILD") return ChildIcon;
    return InfantIcon;
  };
  return /* @__PURE__ */ jsx14("div", { className: "gap-semantic-global-sm flex w-full flex-col", children: /* @__PURE__ */ jsx14("div", { className: "gap-semantic-global-sm flex flex-col items-start self-stretch md:flex-row", children: categories.map((category) => /* @__PURE__ */ jsx14("div", { children: /* @__PURE__ */ jsxs9("div", { className: "gap-semantic-global-2xs typography-body-sm-medium text-semantic-global-text-light flex items-center", children: [
    (() => {
      const CategoryIcon = getCategoryIcon(category.type);
      return /* @__PURE__ */ jsx14(CategoryIcon, { className: "text-semantic-global-primary-darkest", size: "md" });
    })(),
    category.title
  ] }) }, category.type)) }) });
};

// src/components/confirmation/passenger/Passenger.tsx
import { AccountIcon } from "@dfds-frontend/navigator-icons/icons";

// src/components/atoms/loading-spinner/LoadingSpinner.tsx
import { clsx as clsx14 } from "clsx";
import { jsx as jsx15, jsxs as jsxs10 } from "react/jsx-runtime";
var loadingSpinnerVariants = cva("size-fit", {
  defaultVariants: {
    animate: true,
    darkModeVariant: "default",
    size: "lg"
  },
  variants: {
    animate: {
      false: "",
      true: "motion-safe:animate-[spin_800ms_linear_infinite]"
    },
    darkModeVariant: {
      default: "text-semantic-global-primary-default",
      white: "text-semantic-global-text-lightest"
    },
    size: {
      lg: "[&_svg]:size-[24px]",
      md: "[&_svg]:size-[16px]",
      xl: "[&_svg]:size-[32px]"
    }
  }
});
var LoadingSpinner = (_a) => {
  var _b = _a, {
    animate = true,
    className,
    darkModeVariant = "default",
    size
  } = _b, props = __objRest(_b, [
    "animate",
    "className",
    "darkModeVariant",
    "size"
  ]);
  return /* @__PURE__ */ jsx15(
    "div",
    __spreadProps(__spreadValues({
      "aria-label": "Loading",
      "aria-live": "polite",
      className: clsx14(
        loadingSpinnerVariants({
          animate,
          darkModeVariant,
          size
        }),
        className
      ),
      role: "progressbar"
    }, props), {
      children: /* @__PURE__ */ jsxs10("svg", { fill: "none", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: [
        /* @__PURE__ */ jsx15(
          "path",
          {
            d: "M22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7362 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2V4.5C12.9849 4.5 13.9602 4.69399 14.8701 5.0709C15.7801 5.44781 16.6069 6.00026 17.3033 6.6967C17.9997 7.39314 18.5522 8.21993 18.9291 9.12987C19.306 10.0398 19.5 11.0151 19.5 12H22Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx15(
          "path",
          {
            d: "M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51808 6.3459 2.7612 8.17317C2.00433 10.0004 1.80629 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92893 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12H19.5C19.5 13.4834 19.0601 14.9334 18.236 16.1668C17.4119 17.4001 16.2406 18.3614 14.8701 18.9291C13.4997 19.4968 11.9917 19.6453 10.5368 19.3559C9.08196 19.0665 7.74559 18.3522 6.6967 17.3033C5.64781 16.2544 4.9335 14.918 4.64411 13.4632C4.35472 12.0083 4.50325 10.5003 5.0709 9.12987C5.63856 7.75943 6.59985 6.58809 7.83322 5.76398C9.06659 4.93987 10.5166 4.5 12 4.5V2Z",
            fill: "currentColor",
            opacity: "0.36"
          }
        ),
        /* @__PURE__ */ jsx15(
          "path",
          {
            d: "M10.9004 3C10.9004 2.44772 11.3481 2 11.9004 2H12.1004C12.6527 2 13.1004 2.44772 13.1004 3V3.5C13.1004 4.05228 12.6527 4.5 12.1004 4.5H11.9004C11.3481 4.5 10.9004 4.05228 10.9004 3.5V3Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx15(
          "path",
          {
            d: "M21 10.8999C21.5523 10.8999 22 11.3476 22 11.8999V12.0999C22 12.6522 21.5523 13.0999 21 13.0999H20.5C19.9477 13.0999 19.5 12.6522 19.5 12.0999V11.8999C19.5 11.3476 19.9477 10.8999 20.5 10.8999H21Z",
            fill: "currentColor"
          }
        )
      ] })
    })
  );
};

// src/components/atoms/badge/Badge.tsx
import { clsx as clsx15 } from "clsx";
import { Icon } from "@dfds-frontend/navigator-icons";
import { InformationIcon, StatusErrorIcon, StatusSuccessIcon, StatusWarningIcon } from "@dfds-frontend/navigator-icons/icons";
import { jsx as jsx16, jsxs as jsxs11 } from "react/jsx-runtime";
var badgeBaseStyles = cva(
  "rounded-full inline-flex w-fit whitespace-nowrap items-center typography-body-sm-medium h-fit justify-center gap-semantic-global-2xs",
  {
    compoundVariants: [
      {
        className: "p-0",
        iconOnly: true,
        size: "sm"
      },
      {
        className: "",
        iconOnly: true,
        size: "md"
      },
      {
        className: "px-semantic-global-xs py-semantic-global-2xs",
        iconOnly: false,
        size: "sm"
      },
      {
        className: "px-semantic-global-sm py-semantic-global-xs",
        iconOnly: false,
        size: "md"
      }
    ],
    defaultVariants: {
      iconOnly: false,
      size: "md"
    },
    variants: {
      iconOnly: {
        false: "",
        true: ""
      },
      size: {
        md: "",
        sm: "py-semantic-global-2xs"
      }
    }
  }
);
var badgeStatusStyles = cva("", {
  compoundVariants: [
    {
      className: "bg-semantic-global-neutral-lighter text-semantic-global-neutral-darker [&_svg]:text-semantic-global-neutral-darker",
      emphasis: "low",
      status: "neutral"
    },
    {
      className: "bg-semantic-global-neutral-dark text-semantic-global-text-lightest [&_svg]:text-semantic-global-text-lightest",
      emphasis: "high",
      status: "neutral"
    },
    {
      className: "bg-semantic-global-info-lightest text-semantic-global-info-dark [&_svg]:text-semantic-global-info-dark",
      emphasis: "low",
      status: "info"
    },
    {
      className: "bg-semantic-global-info-dark text-semantic-global-text-lightest [&_svg]:text-semantic-global-text-lightest",
      emphasis: "high",
      status: "info"
    },
    {
      className: "bg-semantic-global-success-lightest text-semantic-global-success-darker [&_svg]:text-semantic-global-success-darker",
      emphasis: "low",
      status: "success"
    },
    {
      className: "bg-semantic-global-success-dark text-semantic-global-text-lightest [&_svg]:text-semantic-global-text-lightest",
      emphasis: "high",
      status: "success"
    },
    {
      className: "bg-semantic-global-warning-lightest text-semantic-global-warning-darker [&_svg]:text-semantic-global-warning-darker",
      emphasis: "low",
      status: "warning"
    },
    {
      className: "bg-semantic-global-warning-light text-semantic-global-text-default [&_svg]:text-semantic-global-text-default",
      emphasis: "high",
      status: "warning"
    },
    {
      className: "bg-semantic-global-danger-lightest text-semantic-global-danger-darker [&_svg]:text-semantic-global-danger-darker",
      emphasis: "low",
      status: "danger"
    },
    {
      className: "bg-semantic-global-danger-dark text-semantic-global-text-lightest [&_svg]:text-semantic-global-text-lightest",
      emphasis: "high",
      status: "danger"
    }
  ],
  defaultVariants: {
    emphasis: "low",
    status: "neutral"
  },
  variants: {
    emphasis: {
      high: "",
      low: ""
    },
    status: {
      danger: "",
      info: "",
      neutral: "",
      success: "",
      warning: ""
    }
  }
});
var DEFAULT_STATUS_ICONS = {
  danger: StatusErrorIcon,
  info: InformationIcon,
  neutral: InformationIcon,
  success: StatusSuccessIcon,
  warning: StatusWarningIcon
};
var BADGE_ICON_SIZE_MAP = {
  md: "md",
  sm: "sm"
};
var badgeSizeToIconSize = (size) => BADGE_ICON_SIZE_MAP[size != null ? size : "md"];
var Badge = (_a) => {
  var _b = _a, {
    children,
    className,
    "data-e2e": dataE2e,
    emphasis = "low",
    icon,
    label,
    showIcon = true,
    size = "md",
    status = "neutral"
  } = _b, props = __objRest(_b, [
    "children",
    "className",
    "data-e2e",
    "emphasis",
    "icon",
    "label",
    "showIcon",
    "size",
    "status"
  ]);
  const content = label != null ? label : children;
  const resolvedStatus = status != null ? status : "neutral";
  const resolvedIcon = icon != null ? icon : DEFAULT_STATUS_ICONS[resolvedStatus];
  const iconOnly = !content && showIcon;
  return /* @__PURE__ */ jsxs11(
    "div",
    __spreadProps(__spreadValues({
      className: clsx15(badgeBaseStyles({ iconOnly, size }), badgeStatusStyles({ emphasis, status: resolvedStatus }), className),
      "data-e2e": dataE2e,
      "data-icon-only": iconOnly
    }, props), {
      children: [
        showIcon ? /* @__PURE__ */ jsx16(Icon, { className: "shrink-0", icon: resolvedIcon, size: badgeSizeToIconSize(size) }) : null,
        content
      ]
    })
  );
};

// src/components/atoms/inline-notification/InlineNotification.tsx
import { createElement } from "react";
import { clsx as clsx16 } from "clsx";
import { InformationIcon as InformationIcon2, StatusErrorIcon as StatusErrorIcon2, StatusSuccessIcon as StatusSuccessIcon2, StatusWarningIcon as StatusWarningIcon2 } from "@dfds-frontend/navigator-icons/icons";
import { jsx as jsx17, jsxs as jsxs12 } from "react/jsx-runtime";
var inlineNotificationVariants = cva("flex gap-semantic-global-sm border p-semantic-global-sm text-semantic-global-primary-darkest", {
  defaultVariants: {
    variant: "info"
  },
  variants: {
    variant: {
      danger: "border-semantic-global-danger-light bg-semantic-global-danger-lightest [&_svg]:text-semantic-global-danger-default",
      info: "border-semantic-global-info-light bg-semantic-global-info-lightest [&_svg]:text-semantic-global-info-default",
      loading: "border-semantic-global-info-light bg-semantic-global-info-lightest",
      success: "border-semantic-global-success-light bg-semantic-global-success-lightest [&_svg]:text-semantic-global-success-default",
      warning: "border-semantic-global-warning-light bg-semantic-global-warning-lightest [&_svg]:text-semantic-global-warning-default"
    }
  }
});
var STATUS_ICONS = {
  danger: StatusErrorIcon2,
  info: InformationIcon2,
  success: StatusSuccessIcon2,
  warning: StatusWarningIcon2
};
var InlineNotification = (_a) => {
  var _b = _a, { children, className, heading, variant = "info" } = _b, props = __objRest(_b, ["children", "className", "heading", "variant"]);
  return /* @__PURE__ */ jsxs12("div", __spreadProps(__spreadValues({ className: clsx16(inlineNotificationVariants({ variant }), className), role: "status" }, props), { children: [
    variant === "loading" ? /* @__PURE__ */ jsx17(LoadingSpinner, {}) : createElement(STATUS_ICONS[variant], { className: "mt-0.5 shrink-0", size: "lg" }),
    /* @__PURE__ */ jsxs12("div", { className: "gap-semantic-global-2xs flex min-w-0 flex-1 flex-col", children: [
      heading ? /* @__PURE__ */ jsx17("p", { className: "typography-body-md-medium text-semantic-global-primary-darkest", children: heading }) : null,
      children
    ] })
  ] }));
};

// src/components/atoms/price/Price.tsx
import getSymbolFromCurrency from "currency-symbol-map";
import { jsxs as jsxs13 } from "react/jsx-runtime";
var Price = ({ currency, dataAttr, price }) => {
  var _a;
  const currencySymbol = currency === "MAD" ? "DH" : currency ? getSymbolFromCurrency(currency) : void 0;
  const isNegative = price < 0;
  return /* @__PURE__ */ jsxs13("span", { "data-e2e": dataAttr, children: [
    isNegative ? "-\xA0" : null,
    currencySymbol,
    (_a = Math.abs(price)) == null ? void 0 : _a.toFixed(2)
  ] });
};

// src/components/atoms/mark-down/MarkDown.tsx
import ReactMarkdown from "react-markdown";
import { jsx as jsx18 } from "react/jsx-runtime";
var MarkDown = ({ bodySize = "typography-body-md-regular", children }) => {
  return /* @__PURE__ */ jsx18(
    ReactMarkdown,
    {
      components: {
        a: ({ children: children2, href }) => /* @__PURE__ */ jsx18("a", { href, className: `text-semantic-global-primary-default underline ${bodySize}`, target: "_blank", rel: "noopener noreferrer", children: children2 }),
        blockquote: ({ children: children2 }) => /* @__PURE__ */ jsx18(
          "blockquote",
          {
            className: `border-semantic-global-border-light pl-semantic-global-sm text-semantic-global-text-default border-l-4 ${bodySize}`,
            children: children2
          }
        ),
        code: ({ children: children2 }) => /* @__PURE__ */ jsx18(
          "code",
          {
            className: `bg-semantic-global-background-light px-semantic-global-2xs text-semantic-global-text-default rounded ${bodySize}`,
            children: children2
          }
        ),
        h1: ({ children: children2 }) => /* @__PURE__ */ jsx18("h1", { className: "typography-heading-xl text-semantic-global-text-default", children: children2 }),
        h2: ({ children: children2 }) => /* @__PURE__ */ jsx18("h2", { className: "typography-heading-lg text-semantic-global-text-default", children: children2 }),
        h3: ({ children: children2 }) => /* @__PURE__ */ jsx18("h3", { className: "typography-heading-md text-semantic-global-text-default", children: children2 }),
        li: ({ children: children2 }) => /* @__PURE__ */ jsx18("li", { className: `text-semantic-global-text-default ${bodySize}`, children: children2 }),
        ol: ({ children: children2 }) => /* @__PURE__ */ jsx18("ol", { className: "pl-semantic-global-md list-decimal", children: children2 }),
        p: ({ children: children2 }) => /* @__PURE__ */ jsx18("p", { className: `text-semantic-global-text-default ${bodySize}`, children: children2 }),
        strong: ({ children: children2 }) => /* @__PURE__ */ jsx18("strong", { className: "typography-body-md-bold text-semantic-global-primary-darkest", children: children2 }),
        ul: ({ children: children2 }) => /* @__PURE__ */ jsx18("ul", { className: "pl-semantic-global-md mt-semantic-global-md list-disc", children: children2 })
      },
      children
    }
  );
};

// src/components/atoms/link-button/LinkButton.tsx
import { clsx as clsx17 } from "clsx";
import { jsx as jsx19, jsxs as jsxs14 } from "react/jsx-runtime";
var linkButtonVariants = cva(
  "bg-semantic-global-none inline-flex justify-center cursor-pointer w-fit py-semantic-global-xs px-0 font-primitive-dfds-sans font-primitive-medium tracking-primitive-0 align-middle items-center focus-visible:outline-semantic-global-primary-default transition-colors duration-150 focus-visible:outline-2 focus-visible:outline-offset-2 no-underline",
  {
    defaultVariants: {
      size: "md",
      variant: "primary"
    },
    variants: {
      size: {
        lg: "py-semantic-global-sm px-semantic-global-lg gap-semantic-global-sm text-semantic-body-lg leading-semantic-body-lg",
        md: "py-semantic-global-xs gap-semantic-global-xs text-semantic-body-md leading-semantic-body-md",
        sm: "py-semantic-global-2xs gap-semantic-global-xs text-semantic-body-sm leading-semantic-body-sm",
        xs: "py-[2px] py-semantic-global-3xs gap-semantic-global-xs text-semantic-body-sm leading-semantic-body-sm"
      },
      variant: {
        ghostPrimary: "text-semantic-global-primary-default hover:text-semantic-global-primary-dark active:bg-semantic-form-controls-background-ghost-pressed active:text-semantic-global-primary-darker",
        ghostSecondary: "text-semantic-global-text-default hover:text-semantic-global-text-default active:bg-semantic-form-controls-background-ghost-pressed active:text-semantic-global-text-default",
        primary: "border border-transparent bg-semantic-global-primary-default text-semantic-global-text-lightest hover:bg-semantic-global-primary-dark active:bg-semantic-global-primary-darker px-semantic-global-md",
        secondary: "border border-solid border-semantic-global-primary-darkest text-semantic-global-text-default hover:bg-semantic-form-controls-background-ghost-hover hover:text-semantic-global-primary-darkest active:bg-semantic-form-controls-background-ghost-pressed active:text-semantic-global-primary-darkest px-semantic-global-md"
      }
    }
  }
);
var LinkButton = (_a) => {
  var _b = _a, {
    children,
    className,
    disabled = false,
    disabledWhileLoading = true,
    fullWidth = false,
    href,
    icon,
    iconPosition = "left",
    isLoading = false,
    size = "md",
    target,
    variant = "primary"
  } = _b, props = __objRest(_b, [
    "children",
    "className",
    "disabled",
    "disabledWhileLoading",
    "fullWidth",
    "href",
    "icon",
    "iconPosition",
    "isLoading",
    "size",
    "target",
    "variant"
  ]);
  const isDisabled = disabled || isLoading && disabledWhileLoading;
  return /* @__PURE__ */ jsxs14(
    "a",
    __spreadProps(__spreadValues({
      "aria-disabled": isDisabled,
      className: clsx17(
        linkButtonVariants({ size, variant }),
        fullWidth ? "w-full justify-center" : "",
        isDisabled && "pointer-events-none cursor-not-allowed opacity-75",
        className
      ),
      href: isDisabled ? void 0 : href,
      target
    }, props), {
      children: [
        isLoading ? /* @__PURE__ */ jsx19(LoadingSpinner, { animate: true, darkModeVariant: "white", size: "xl" }) : null,
        icon && iconPosition === "left" && !isLoading ? /* @__PURE__ */ jsx19("span", { className: "shrink-0", children: icon }) : null,
        isLoading ? null : children,
        icon && iconPosition === "right" && !isLoading ? /* @__PURE__ */ jsx19("span", { className: "shrink-0", children: icon }) : null
      ]
    })
  );
};

// src/components/confirmation/leg-card/PriceDots.tsx
import { jsx as jsx20 } from "react/jsx-runtime";
var PriceDots = ({ className }) => {
  return /* @__PURE__ */ jsx20(
    "span",
    {
      "aria-hidden": true,
      className: className != null ? className : "mx-semantic-global-xs text-semantic-global-border-light mb-[0.35em] h-[2px] min-w-0 flex-1 self-end bg-[radial-gradient(circle,_currentColor_1.5px,_transparent_1.5px)] bg-[length:8px_4px] bg-center bg-repeat-x"
    }
  );
};

// src/components/confirmation/passenger/PassengerItem.tsx
import { jsx as jsx21, jsxs as jsxs15 } from "react/jsx-runtime";
var PassengerItem = ({ attr, showDots, text, value }) => {
  return /* @__PURE__ */ jsxs15("div", { className: "flex w-full flex-row items-center", "data-e2e": attr, children: [
    /* @__PURE__ */ jsx21("span", { className: "typography-body-sm-regular text-semantic-global-text-default", children: text }),
    showDots ? /* @__PURE__ */ jsx21(PriceDots, {}) : null,
    /* @__PURE__ */ jsx21("span", { className: "typography-body-xs-regular text-semantic-global-text-light ml-auto", children: value })
  ] });
};

// src/components/confirmation/passenger/Passenger.tsx
import { jsx as jsx22, jsxs as jsxs16 } from "react/jsx-runtime";
var Passenger = ({ category, children, couponNumber, fullname }) => {
  return /* @__PURE__ */ jsx22("div", { className: "border-semantic-global-border-light p-semantic-global-md flex w-full border border-solid", children: /* @__PURE__ */ jsxs16("div", { className: "gap-semantic-global-sm flex w-full flex-col items-start self-stretch", children: [
    /* @__PURE__ */ jsx22(Badge, { icon: AccountIcon, status: "info", size: "sm", children: category }),
    /* @__PURE__ */ jsx22("span", { "data-e2e": "passenger-fullname", className: "typography-body-md-medium text-semantic-global-text-default", children: fullname }),
    couponNumber ? /* @__PURE__ */ jsx22(PassengerItem, { attr: "passenger-coupon-number", showDots: true, text: couponNumber.label, value: couponNumber.value }) : null,
    children
  ] }) });
};

// src/components/confirmation/route-details/RouteDetails.tsx
import { RoroFerryIcon } from "@dfds-frontend/navigator-icons/icons";
import { Fragment as Fragment5, jsx as jsx23, jsxs as jsxs17 } from "react/jsx-runtime";
var RouteDetails = ({ outboundRoute, outboundTime, returnLeg, returnRoute, returnTime }) => {
  return /* @__PURE__ */ jsx23("div", { className: "gap-semantic-global-2xs flex flex-col", children: /* @__PURE__ */ jsx23("div", { className: "flex w-full flex-1 flex-row", children: /* @__PURE__ */ jsxs17("div", { className: "gap-semantic-global-sm flex flex-1 flex-row", children: [
    /* @__PURE__ */ jsxs17("div", { className: "flex flex-col", children: [
      /* @__PURE__ */ jsx23("div", { className: "typography-number-sm text-semantic-global-text-default", children: outboundTime }),
      /* @__PURE__ */ jsx23(
        "div",
        {
          "data-e2e": returnLeg ? "summary-departure-port-return" : "summary-departure-port-outbound",
          className: "typography-body-lg-regular text-semantic-global-text-default",
          children: outboundRoute
        }
      )
    ] }),
    /* @__PURE__ */ jsx23("div", { className: "gap-primitive-8 text-semantic-global-text-default flex flex-1 items-center justify-center", children: /* @__PURE__ */ jsx23(RouteIllustration, {}) }),
    /* @__PURE__ */ jsxs17("div", { className: "flex flex-col", children: [
      /* @__PURE__ */ jsx23("div", { className: "typography-number-sm text-semantic-global-text-default ml-auto", children: returnTime }),
      /* @__PURE__ */ jsx23(
        "div",
        {
          "data-e2e": returnLeg ? "summary-arrival-port-return" : "summary-arrival-port-outbound",
          className: "typography-body-lg-regular text-semantic-global-text-default ml-auto",
          children: returnRoute
        }
      )
    ] })
  ] }) }) });
};
var RouteIllustration = () => {
  return /* @__PURE__ */ jsxs17(Fragment5, { children: [
    /* @__PURE__ */ jsx23("div", { className: "text-semantic-global-border-light h-[2px] min-w-0 flex-1 bg-[radial-gradient(circle,_currentColor_1.5px,_transparent_1.5px)] bg-[length:8px_4px] bg-center bg-repeat-x" }),
    /* @__PURE__ */ jsx23(RoroFerryIcon, { className: "text-semantic-global-disabled-default", size: "md" }),
    /* @__PURE__ */ jsx23("div", { className: "text-semantic-global-border-light h-[2px] min-w-0 flex-1 bg-[radial-gradient(circle,_currentColor_1.5px,_transparent_1.5px)] bg-[length:8px_4px] bg-center bg-repeat-x" })
  ] });
};

// src/components/confirmation/show-on-map/ShowOnMap.tsx
import { isIOS } from "react-device-detect";
import { LocationPinIcon } from "@dfds-frontend/navigator-icons/icons";
import { jsx as jsx24 } from "react/jsx-runtime";
var locations = [
  { lat: 50.97356, lon: 1.880078, unlocode: "FRCQF" },
  // Calais
  { lat: 51.01640520000001, lon: 2.198785799999996, unlocode: "FRDKK" },
  // Dunkirk
  { lat: 48.64256, lon: -2.02342, unlocode: "FRSML" },
  // St Malo
  { lat: 51.1283172, lon: 1.3332169999999905, unlocode: "GBDVR" },
  // Dover
  { lat: 50.81204, lon: -1.08857, unlocode: "GBPOO" },
  // Portsmouth
  { lat: 49.44711, lon: -2.53312, unlocode: "GBSYP" },
  // Guernsey
  { lat: 49.17945, lon: -2.11677, unlocode: "JESTH" },
  // Jersey
  { lat: 35.85766, lon: -5.53872, unlocode: "MAPTM" },
  // Tanger Med
  { lat: 36.13199, lon: -5.43323, unlocode: "ESALG" },
  // Algeciras
  { lat: 35.89588, lon: -5.32366, unlocode: "ESCEU" }
  // Ceuta
];
var ShowOnMap = ({ portUnlocode, title }) => {
  const location = locations.find((loc) => loc.unlocode === portUnlocode);
  if (!location) return null;
  const googleMapsUrl = `https://www.google.com/maps?q=loc:${location.lat},${location.lon}`;
  const appleMapsUrl = `http://maps.apple.com/?ll=${location.lat},${location.lon}`;
  const href = isIOS ? appleMapsUrl : googleMapsUrl;
  return /* @__PURE__ */ jsx24(
    LinkButton,
    {
      "data-e2e": "show-on-map",
      variant: "ghostPrimary",
      icon: /* @__PURE__ */ jsx24(LocationPinIcon, { size: "lg" }),
      iconPosition: "right",
      href,
      target: "_blank",
      children: title
    }
  );
};

// src/components/confirmation/time-details/TimeDetails.tsx
import { jsx as jsx25, jsxs as jsxs18 } from "react/jsx-runtime";
var TimeDetails = ({ children, date, legTitle }) => {
  return /* @__PURE__ */ jsxs18("div", { className: "gap-semantic-global-2xs flex flex-col md:gap-0", children: [
    /* @__PURE__ */ jsxs18("div", { className: "flex flex-row items-center", children: [
      /* @__PURE__ */ jsxs18("div", { className: "typography-heading-sm text-semantic-global-text-default", children: [
        legTitle,
        ":"
      ] }),
      children ? children : null
    ] }),
    /* @__PURE__ */ jsx25("div", { className: "typography-heading-sm text-semantic-global-text-default", children: date })
  ] });
};

// src/components/confirmation/leg-card/LegCardHeader.tsx
import { FerryOutboundIcon, FerryReturnIcon, FerryRoundTripIcon } from "@dfds-frontend/navigator-icons/icons";
import { jsx as jsx26, jsxs as jsxs19 } from "react/jsx-runtime";
var LegCardHeader = ({ badgeText, returnLeg, showBothWaysIcon, showShipLegIcon, title }) => {
  const truncatedBadgeText = badgeText && badgeText.length > 40 ? `${badgeText.slice(0, 40)}...` : badgeText;
  return /* @__PURE__ */ jsxs19("div", { className: "flex flex-row justify-between", children: [
    title && !badgeText ? /* @__PURE__ */ jsx26("h2", { className: "typography-heading-sm text-semantic-global-text-default", children: title }) : null,
    badgeText && !title ? /* @__PURE__ */ jsx26(Badge, { label: truncatedBadgeText, emphasis: "high", status: "neutral", size: "sm", showIcon: false }) : null,
    showShipLegIcon && !showBothWaysIcon ? /* @__PURE__ */ jsx26("div", { className: "text-semantic-global-text-default mb-auto", children: returnLeg ? /* @__PURE__ */ jsx26("div", { className: "flex flex-col", children: /* @__PURE__ */ jsx26("div", { className: "text-semantic-global-background-deep-blue", children: /* @__PURE__ */ jsx26(FerryReturnIcon, { size: "lg" }) }) }) : /* @__PURE__ */ jsx26("div", { className: "flex flex-col", children: /* @__PURE__ */ jsx26(FerryOutboundIcon, { size: "lg" }) }) }) : null,
    showBothWaysIcon ? /* @__PURE__ */ jsx26("div", { className: "text-semantic-global-background-deep-blue mb-auto", children: /* @__PURE__ */ jsx26(FerryRoundTripIcon, { size: "lg" }) }) : null
  ] });
};

// src/components/confirmation/leg-card/LegCard.tsx
import { jsx as jsx27, jsxs as jsxs20 } from "react/jsx-runtime";
var LegCard = ({ attr, cardDetails, children, routeDetails, terminalDetails, timeDetails }) => {
  const { badgeText, returnLeg, showBothWaysIcon, showShipLegIcon, title } = cardDetails;
  return /* @__PURE__ */ jsxs20(
    "div",
    {
      "data-e2e": attr || "LegCardDesktop",
      className: "border-semantic-global-border-light p-semantic-global-md bg-semantic-global-background-light-sand gap-semantic-global-md flex w-full flex-col border",
      children: [
        /* @__PURE__ */ jsx27(
          LegCardHeader,
          {
            title,
            badgeText,
            showShipLegIcon,
            showBothWaysIcon,
            returnLeg
          }
        ),
        timeDetails ? /* @__PURE__ */ jsx27("div", { className: "md:mb-semantic-global-md", children: /* @__PURE__ */ jsx27(TimeDetails, __spreadProps(__spreadValues({}, timeDetails), { children: terminalDetails ? /* @__PURE__ */ jsx27("span", { className: "ml-auto hidden lg:block", children: /* @__PURE__ */ jsx27(ShowOnMap, { title: terminalDetails.resource, portUnlocode: terminalDetails.portUnlocode }) }) : null })) }) : null,
        routeDetails ? /* @__PURE__ */ jsx27(RouteDetails, __spreadValues({ returnLeg }, routeDetails)) : null,
        children ? /* @__PURE__ */ jsx27("div", { className: "gap-semantic-global-2xs flex flex-col", children }) : null
      ]
    }
  );
};

// src/components/confirmation/leg-card/LegCardItem.tsx
import { jsx as jsx28, jsxs as jsxs21 } from "react/jsx-runtime";
var LegCardItem = ({ attr, price, showDots = false, text, value }) => {
  return /* @__PURE__ */ jsxs21("div", { "data-e2e": attr, className: "flex flex-row justify-between", children: [
    /* @__PURE__ */ jsx28("span", { className: "typography-body-md-regular text-semantic-global-text-light", children: text }),
    showDots ? /* @__PURE__ */ jsx28(PriceDots, {}) : null,
    /* @__PURE__ */ jsx28("span", { className: "typography-body-md-medium text-semantic-global-text-default ml-auto", children: value }),
    price !== void 0 ? /* @__PURE__ */ jsx28("span", { className: "typography-body-md-medium text-semantic-global-text-default ml-auto", children: /* @__PURE__ */ jsx28(Price, { price: price.amount, currency: price.currency }) }) : null
  ] });
};

// src/components/confirmation/leg-card/LegCardPriceItem.tsx
import { clsx as clsx18 } from "clsx";
import { jsx as jsx29, jsxs as jsxs22 } from "react/jsx-runtime";
var LegCardPriceItem = ({
  attr,
  currency,
  hidePrice = false,
  price,
  showDots = false,
  text,
  totalPrice = false
}) => {
  return /* @__PURE__ */ jsxs22("div", { className: "flex flex-row items-end", "data-e2e": attr, children: [
    /* @__PURE__ */ jsx29(
      "span",
      {
        className: clsx18(
          "text-semantic-global-text-light",
          totalPrice ? "typography-body-md-medium font-bold" : "typography-body-md-regular"
        ),
        children: text
      }
    ),
    showDots ? /* @__PURE__ */ jsx29(PriceDots, {}) : null,
    /* @__PURE__ */ jsx29(
      "span",
      {
        className: clsx18(
          "text-semantic-global-text-default ml-auto",
          totalPrice ? "typography-body-md-medium" : "typography-body-md-regular"
        ),
        children: hidePrice ? null : /* @__PURE__ */ jsx29(Price, { price, currency })
      }
    )
  ] });
};

// src/components/confirmation/booking-confirmation-header/BookingConfirmationHeader.tsx
import { jsx as jsx30 } from "react/jsx-runtime";
var BookingConfirmationHeader = ({ title, version }) => {
  return /* @__PURE__ */ jsx30("h2", { "data-e2e": "booking-ref", className: "typography-heading-md text-semantic-global-text-default", children: version ? `${title}-${version}` : title });
};

// src/components/confirmation/booking-confirmation/BookingConfirmation.tsx
import React3 from "react";
import { clsx as clsx24 } from "clsx";
import { compoundRoutes, getVehicleResourceKey as getVehicleResourceKey2, mapUnloRoute, PaxObProducts, sogRoutes } from "@dfds-pax/utils";

// src/components/confirmation/booking-confirmation/lib/departure-utils.ts
import { format, isValid, parseISO } from "date-fns";
import { getDatepickerLocale } from "@dfds-pax/utils";
var formatDepartureDate = (departureDateLocal, locale) => {
  const parsedIsoDate = parseISO(departureDateLocal);
  const date = isValid(parsedIsoDate) ? parsedIsoDate : new Date(departureDateLocal);
  if (!isValid(date)) return departureDateLocal;
  return format(date, "EEEE d MMMM yyyy", { locale: getDatepickerLocale(locale != null ? locale : "en-gb") });
};

// src/components/confirmation/booking-confirmation/lib/vehicle-utils.ts
import {
  BicycleIcon,
  BusIcon,
  CampervanIcon,
  CaravanIcon,
  CarIcon,
  CarRoofBoxIcon,
  CarTrailerIcon,
  MotorcycleIcon,
  MotorcycleSidecarIcon
} from "@dfds-frontend/navigator-icons/icons";
var getVehicleIcon = (vehicleCode) => {
  switch (vehicleCode) {
    case "BIKV":
    case "BIKVRES":
      return BicycleIcon;
    case "CAR":
    case "CARH":
    case "CARLW":
      return CarIcon;
    case "CARZ":
    case "CARX":
      return CarRoofBoxIcon;
    case "MCVB":
    case "MCVBRES":
    case "MCVM":
    case "MCVX":
    case "MCVS":
    case "PVANB":
    case "PVANM":
    case "PVANBRES":
      return CampervanIcon;
    case "MIBUS":
    case "BUSRES":
      return BusIcon;
    case "MOC":
    case "MOCRES":
      return MotorcycleIcon;
    case "MOCS":
      return MotorcycleSidecarIcon;
    case "CAMB":
    case "CAMS":
      return CaravanIcon;
    case "TRAB":
    case "TRAX":
    case "TRAS":
    case "TRAZ":
    case "TRAZRES":
      return CarTrailerIcon;
    default:
      return CarIcon;
  }
};

// src/components/business/Route/Route.tsx
import { ArrowBackIcon, ArrowForwardIcon, ArrowReverseIcon, FerryRoundTripIcon as FerryRoundTripIcon2 } from "@dfds-frontend/navigator-icons/icons";
import { jsx as jsx31, jsxs as jsxs23 } from "react/jsx-runtime";
var Route = ({ homeboundRoute, outboundRoute, t }) => {
  const outboundAndHomeboundRoutesAreTheSame = homeboundRoute ? outboundRoute.departureUnLoCode === homeboundRoute.arrivalUnLoCode && outboundRoute.arrivalUnLoCode === homeboundRoute.departureUnLoCode : false;
  return /* @__PURE__ */ jsxs23("div", { className: "gap-primitive-8 lg:gap-semantic-global-sm flex flex-row", children: [
    /* @__PURE__ */ jsx31(FerryRoundTripIcon2, { className: "text-dfds-text-dark-primary size-6 lg:size-5" }),
    outboundAndHomeboundRoutesAreTheSame ? /* @__PURE__ */ jsxs23("div", { className: "flex flex-row items-center", children: [
      /* @__PURE__ */ jsx31("span", { className: "typography-body-md-regular text-semantic-global-text-default", "data-e2e": "booking-summary-outbound-departure", children: t(`${outboundRoute.departureUnLoCode}`) }),
      /* @__PURE__ */ jsx31("span", { className: "mx-primitive-8", children: /* @__PURE__ */ jsx31(ArrowReverseIcon, {}) }),
      /* @__PURE__ */ jsx31("span", { className: "typography-body-md-regular text-semantic-global-text-default", "data-e2e": "booking-summary-return-departure", children: t(`${outboundRoute.arrivalUnLoCode}`) })
    ] }) : /* @__PURE__ */ jsxs23("div", { className: "flex flex-col", children: [
      /* @__PURE__ */ jsxs23("div", { className: "flex flex-row items-center", children: [
        /* @__PURE__ */ jsx31("span", { className: "typography-body-md-regular text-semantic-global-text-default", "data-e2e": "booking-summary-outbound-departure", children: t(`${outboundRoute.departureUnLoCode}`) }),
        /* @__PURE__ */ jsx31("span", { className: "mx-primitive-8", children: /* @__PURE__ */ jsx31(ArrowForwardIcon, {}) }),
        /* @__PURE__ */ jsx31("span", { className: "typography-body-md-regular text-semantic-global-text-default", "data-e2e": "booking-summary-return-departure", children: t(`${outboundRoute.arrivalUnLoCode}`) })
      ] }),
      homeboundRoute ? /* @__PURE__ */ jsxs23("div", { className: "flex flex-row items-center", children: [
        /* @__PURE__ */ jsx31("span", { className: "typography-body-md-regular text-semantic-global-text-default", "data-e2e": "booking-summary-outbound-departure", children: t(`${homeboundRoute.arrivalUnLoCode}`) }),
        /* @__PURE__ */ jsx31("span", { className: "mx-primitive-8", children: /* @__PURE__ */ jsx31(ArrowBackIcon, {}) }),
        /* @__PURE__ */ jsx31("span", { className: "typography-body-md-regular text-semantic-global-text-default", "data-e2e": "booking-summary-return-departure", children: t(`${homeboundRoute.departureUnLoCode}`) })
      ] }) : null
    ] })
  ] });
};

// src/components/business/Vehicle/Vehicle.tsx
import { createElement as createElement2 } from "react";
import { getVehicleResourceKey } from "@dfds-pax/utils";
import { jsx as jsx32, jsxs as jsxs24 } from "react/jsx-runtime";
var Vehicle = ({ dataAttr, dimensions, t, vehicleCode }) => {
  const icon = getVehicleIcon(vehicleCode);
  const { height, length } = dimensions;
  return /* @__PURE__ */ jsxs24("div", { className: "gap-primitive-8 lg:gap-semantic-global-md flex flex-row items-center", children: [
    icon ? createElement2(icon, { className: "text-dfds-text-dark-primary size-6 lg:size-5" }) : null,
    /* @__PURE__ */ jsxs24(
      "div",
      {
        className: "typography-body-md-regular text-semantic-global-text-default flex flex-row flex-wrap gap-x-2 text-left",
        "data-e2e": dataAttr,
        children: [
          /* @__PURE__ */ jsx32("span", { children: `1 x ${t(getVehicleResourceKey(vehicleCode))}` }),
          /* @__PURE__ */ jsx32("span", { children: `<${height}m x <${length}m` })
        ]
      }
    )
  ] });
};

// src/components/business/Passengers/Passengers.tsx
import { PassengerIcon as PassengerIcon2 } from "@dfds-frontend/navigator-icons/icons";
import { jsx as jsx33, jsxs as jsxs25 } from "react/jsx-runtime";
var Passengers = ({ adultGroup, childGroup, infantGroup, petGroup, t }) => {
  return /* @__PURE__ */ jsxs25("div", { className: "i gap-primitive-8 lg:gap-semantic-global-md flex flex-row", children: [
    /* @__PURE__ */ jsx33(PassengerIcon2, { className: "text-dfds-text-dark-primary size-6 lg:size-5" }),
    /* @__PURE__ */ jsxs25("div", { className: "flex flex-col justify-start text-start", "data-e2e": "booking-summary-passenger", children: [
      adultGroup.quantity > 0 ? /* @__PURE__ */ jsx33("div", { className: "typography-body-md-regular text-semantic-global-text-default", children: getContentfulString("Adult", adultGroup.quantity, t) }) : null,
      (childGroup == null ? void 0 : childGroup.quantity) && childGroup.quantity > 0 ? /* @__PURE__ */ jsxs25("div", { className: "typography-body-md-regular text-semantic-global-text-default", children: [
        getContentfulString("Child", childGroup.quantity, t),
        /* @__PURE__ */ jsx33("span", { className: "pl-primitive-4", children: formatAges(childGroup.ages, t) })
      ] }) : null,
      (infantGroup == null ? void 0 : infantGroup.quantity) && infantGroup.quantity > 0 ? /* @__PURE__ */ jsxs25("div", { className: "typography-body-md-regular text-semantic-global-text-default", children: [
        getContentfulString("Infant", infantGroup == null ? void 0 : infantGroup.quantity, t),
        /* @__PURE__ */ jsx33("span", { className: "pl-primitive-4", children: formatAges(infantGroup.ages, t) })
      ] }) : null,
      (petGroup == null ? void 0 : petGroup.quantity) && petGroup.quantity > 0 ? /* @__PURE__ */ jsx33("div", { className: "typography-body-md-regular text-semantic-global-text-default", children: getContentfulString("Pet", petGroup.quantity, t) }) : null
    ] })
  ] });
};
var getContentfulString = (resourceKey, count, t) => {
  let key;
  if (resourceKey === "Adult") key = count === 1 ? "ADULT-WITH-PLACEHOLDER" : "ADULT-WITH-PLACEHOLDER-PLURAL";
  if (resourceKey === "Child") key = count === 1 ? "CHILD-WITH-PLACEHOLDER" : "CHILD-WITH-PLACEHOLDER-PLURAL";
  if (resourceKey === "Infant") key = count === 1 ? "INFANT-WITH-PLACEHOLDER" : "INFANT-WITH-PLACEHOLDER-PLURAL";
  if (resourceKey === "Pet") key = count === 1 ? "PET-WITH-PLACEHOLDER" : "PET-WITH-PLACEHOLDER-PLURAL";
  return t(key || "", { count });
};
var formatAges = (ages, t) => {
  if (!(ages == null ? void 0 : ages.length)) return null;
  return `(${[...ages].sort((a, b) => a - b).join(", ")} ${t("YEARS")})`;
};

// src/components/business/TotalPriceBreakdown/TotalPriceBreakdown.tsx
import { clsx as clsx19 } from "clsx";
import { StatusSuccessIcon as StatusSuccessIcon3, YesIcon } from "@dfds-frontend/navigator-icons/icons";
import { jsx as jsx34, jsxs as jsxs26 } from "react/jsx-runtime";
var TotalPriceBreakdown = ({
  beforeBookingCompleted,
  creditsAvailable,
  currency,
  mode,
  offer,
  originalPrice,
  outstandingAmount,
  paidAmount,
  refundAmount,
  residentVehicleDiscount,
  subsidies,
  t,
  total
}) => {
  const shouldHideOfferRows = Boolean(beforeBookingCompleted && residentVehicleDiscount);
  return /* @__PURE__ */ jsxs26(
    "section",
    {
      "data-e2e": "total-price-breakdown",
      className: clsx19("flex w-full flex-col", {
        "bg-semantic-global-background-sand": mode === "sandy",
        "bg-semantic-global-background-white border-semantic-global-border-light border": mode === "pale"
      }),
      children: [
        mode === "pale" ? /* @__PURE__ */ jsxs26("div", { className: "p-semantic-global-md md:p-semantic-global-lg gap-semantic-global-md flex flex-row items-center pb-0!", children: [
          /* @__PURE__ */ jsx34("span", { className: "bg-semantic-global-success-default flex h-6.5 w-6.5 shrink-0 items-center justify-center rounded-full", children: /* @__PURE__ */ jsx34(YesIcon, { className: "text-semantic-global-text-lightest", size: "lg" }) }),
          /* @__PURE__ */ jsx34("h2", { className: "typography-heading-sm text-semantic-global-text-default", children: t("PAYMENT-SUMMARY") })
        ] }) : null,
        /* @__PURE__ */ jsxs26("div", { className: "p-semantic-global-md md:p-semantic-global-lg gap-semantic-global-xs flex flex-col", children: [
          offer && offer.price && !offer.hidePrice || subsidies ? /* @__PURE__ */ jsx34(PriceItem, { text: t("ORIGINAL-PRICE"), attr: "original-amount", price: originalPrice, isLineThrough: true, mode }) : null,
          subsidies ? /* @__PURE__ */ jsx34(PriceItem, { text: t("SUBSIDIES"), attr: "subsidy-amount", price: subsidies > 0 ? -subsidies : subsidies, mode }) : null,
          offer && offer.price && !offer.hidePrice && !shouldHideOfferRows ? /* @__PURE__ */ jsx34(PriceItem, { text: t("DISCOUNT-APPLIED"), attr: "offer-amount", price: offer.price, isOfferPrice: true, mode }) : null,
          creditsAvailable ? /* @__PURE__ */ jsx34(PriceItem, { text: t("CREDITS-AVAILABLE"), attr: "credits-amount", price: Math.abs(creditsAvailable != null ? creditsAvailable : 0), mode }) : null,
          refundAmount ? /* @__PURE__ */ jsx34(PriceItem, { text: t("REFUND-AMOUNT"), attr: "refund-amount", price: refundAmount, mode }) : null,
          outstandingAmount ? /* @__PURE__ */ jsx34(PriceItem, { text: t("OUTSTANDING-AMOUNT-TO-PAY"), attr: "outstanding-amount", price: outstandingAmount, mode }) : null,
          paidAmount ? /* @__PURE__ */ jsx34(PriceItem, { text: t("PAID-AMOUNT"), attr: "paid-amount", price: paidAmount, mode }) : null,
          residentVehicleDiscount ? /* @__PURE__ */ jsxs26("div", { className: "text-semantic-global-success-default flex flex-row items-center", children: [
            /* @__PURE__ */ jsx34("div", { "data-e2e": "resident-vehicle-discount-applied-text", className: "typography-body-md-regular", children: mode === "pale" ? t("RESIDENT-VEHICLE-DISCOUNT-APPLIED") : /* @__PURE__ */ jsx34("span", { children: t("RESIDENT-VEHICLE-DISCOUNT-APPLIED") }) }),
            /* @__PURE__ */ jsx34("div", { className: "ml-auto", children: /* @__PURE__ */ jsx34(StatusSuccessIcon3, { size: "md" }) })
          ] }) : null,
          (offer == null ? void 0 : offer.displayText) && !offer.isTracking && !beforeBookingCompleted ? /* @__PURE__ */ jsxs26("div", { className: "text-semantic-global-success-default flex flex-row items-center", children: [
            /* @__PURE__ */ jsx34("div", { "data-e2e": "offer-display-text", className: "typography-body-md-regular", children: offer.displayText }),
            /* @__PURE__ */ jsx34("div", { className: "ml-auto", children: /* @__PURE__ */ jsx34(StatusSuccessIcon3, { size: "md" }) })
          ] }) : null,
          mode === "sandy" ? /* @__PURE__ */ jsxs26("div", { className: "mt-3.5 flex flex-row items-center justify-between", children: [
            /* @__PURE__ */ jsx34("h3", { "data-e2e": "total-price-label", className: "typography-heading-lg text-semantic-global-primary-darkest", children: t("TOTAL-PRICE") }),
            /* @__PURE__ */ jsx34("span", { "data-e2e": "total-price", className: "typography-number-md text-semantic-global-primary-darkest", children: /* @__PURE__ */ jsx34(Price, { price: total, currency }) })
          ] }) : null
        ] }),
        mode === "pale" ? /* @__PURE__ */ jsxs26("div", { className: "bg-semantic-global-background-sand p-semantic-global-md flex flex-row items-center", children: [
          /* @__PURE__ */ jsx34("span", { "data-e2e": "total-price-label", className: "typography-body-md-medium text-semantic-global-text-default", children: t("TOTAL-PRICE") }),
          /* @__PURE__ */ jsx34("span", { "data-e2e": "total-price", className: "typography-number-md text-semantic-global-text-default ml-auto", children: /* @__PURE__ */ jsx34(Price, { price: total, currency }) })
        ] }) : null
      ]
    }
  );
};
var PriceItem = ({ attr, currency, isLineThrough = false, isOfferPrice, mode, price, text }) => {
  return /* @__PURE__ */ jsxs26("div", { className: clsx19("flex flex-row items-end"), children: [
    /* @__PURE__ */ jsx34(
      "span",
      {
        "data-e2e": attr + "-label",
        className: clsx19(
          "typography-body-md-regular",
          mode === "pale" ? "text-semantic-global-text-light" : "text-semantic-global-primary-darkest"
        ),
        children: text
      }
    ),
    mode === "pale" ? null : /* @__PURE__ */ jsx34(PriceDots, {}),
    /* @__PURE__ */ jsx34(
      "span",
      {
        "data-e2e": attr,
        className: clsx19(
          "typography-body-md-regular",
          isOfferPrice ? "bg-semantic-global-success-dark text-semantic-global-text-lightest p-0.5" : mode === "pale" ? "text-semantic-global-text-light" : "text-semantic-global-primary-darkest",
          isLineThrough ? "line-through" : "",
          "ml-auto shrink-0 whitespace-nowrap"
        ),
        children: /* @__PURE__ */ jsx34(Price, { price, currency })
      }
    )
  ] });
};

// src/components/sog/subsidy-breakdown/SubsidyBreakdown.tsx
import { clsx as clsx20 } from "clsx";
import { ChevronDownIcon as ChevronDownIcon2 } from "@dfds-frontend/navigator-icons/icons";
import { jsx as jsx35, jsxs as jsxs27 } from "react/jsx-runtime";
var SubsidyBreakdown = ({ subsidyLegBreakdown, suppressPrice = false }) => {
  return /* @__PURE__ */ jsx35("div", { className: "gap-semantic-global-xs flex w-full flex-col", children: subsidyLegBreakdown.map((leg, index) => {
    var _a, _b;
    return /* @__PURE__ */ jsxs27(
      "details",
      {
        "data-e2e-leg": leg.isReturnLeg ? "return" : "outbound",
        open: leg.open,
        className: "group flex w-full flex-col",
        children: [
          /* @__PURE__ */ jsxs27("summary", { className: clsx20("flex w-full cursor-pointer list-none flex-row items-center"), children: [
            /* @__PURE__ */ jsx35("span", { className: "text-semantic-global-text-default typography-body-sm-regular", children: leg.title }),
            !suppressPrice && ((_a = leg.subsidyPrices[0]) == null ? void 0 : _a.showPriceDots) ? /* @__PURE__ */ jsx35(PriceDots, {}) : null,
            /* @__PURE__ */ jsxs27("span", { className: clsx20("typography-body-xs-regular text-semantic-global-text-light ml-auto flex flex-row items-center"), children: [
              !suppressPrice && ((_b = leg.subsidyPrices[0]) == null ? void 0 : _b.currency) ? /* @__PURE__ */ jsx35("span", { className: "gap-semantic-global-sm flex flex-row items-center", children: /* @__PURE__ */ jsx35(Price, { price: leg.subsidyPrices.reduce((acc, curr) => acc + curr.amount, 0), currency: leg.subsidyPrices[0].currency }) }) : null,
              /* @__PURE__ */ jsx35(
                ChevronDownIcon2,
                {
                  className: clsx20("text-semantic-global-primary-default transition-transform duration-200 group-open:rotate-180", {
                    "ml-semantic-global-sm": !suppressPrice
                  }),
                  size: "sm"
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ jsx35("div", { className: "pl-semantic-global-md mt-semantic-global-xs gap-semantic-global-xs flex flex-col", children: leg.subsidyPrices.map((subsidyPrice, priceIndex) => /* @__PURE__ */ jsxs27("div", { "data-e2e": "subsidy-item", className: "flex w-full flex-row items-center", children: [
            /* @__PURE__ */ jsx35("span", { "data-e2e": "subsidy-label", className: "typography-body-xs-regular text-semantic-global-text-light", children: subsidyPrice.label }),
            !suppressPrice && subsidyPrice.showPriceDots ? /* @__PURE__ */ jsx35(PriceDots, {}) : null,
            !suppressPrice ? /* @__PURE__ */ jsx35("span", { "data-e2e": "subsidy-price", className: "typography-body-xs-regular text-semantic-global-text-light ml-auto", children: /* @__PURE__ */ jsx35(Price, { price: subsidyPrice.amount, currency: subsidyPrice.currency }) }) : null
          ] }, `${subsidyPrice.label}-${priceIndex}`)) })
        ]
      },
      `${leg.title}-${index}`
    );
  }) });
};

// src/components/confirmation/billing-details/BillingDetails.tsx
import { clsx as clsx21 } from "clsx";
import { jsx as jsx36, jsxs as jsxs28 } from "react/jsx-runtime";
var BillingDetails = ({ email, fullname, phoneNumber, title }) => {
  const rows = [fullname];
  phoneNumber && rows.push(phoneNumber);
  email && rows.push(email);
  return /* @__PURE__ */ jsxs28("section", { className: "border-semantic-global-border-light p-semantic-global-md bg-semantic-global-background-white flex w-full flex-col border", children: [
    /* @__PURE__ */ jsx36("h3", { className: "typography-heading-sm text-semantic-global-text-default mb-semantic-global-md", children: title }),
    /* @__PURE__ */ jsx36("div", { className: "gap-semantic-global-xs flex flex-col", children: rows.map((row, index) => /* @__PURE__ */ jsxs28("div", { className: clsx21("flex flex-row", row.label ? "gap-semantic-global-2xs" : ""), children: [
      /* @__PURE__ */ jsx36("span", { className: "typography-body-md-regular text-semantic-global-text-default", children: row.label ? `${row.label}:` : "" }),
      /* @__PURE__ */ jsx36("span", { className: "typography-body-md-regular text-semantic-global-text-default", children: row.value })
    ] }, index)) })
  ] });
};

// src/components/confirmation/payment-details/PaymentDetails.tsx
import React2 from "react";
import { jsx as jsx37, jsxs as jsxs29 } from "react/jsx-runtime";
var getAttrIndex = (attr) => {
  const match = attr == null ? void 0 : attr.match(/-(\d+)$/);
  return match ? match[1] : "0";
};
var groupItemsByTransaction = (items) => {
  const groups = [];
  let currentIndex = null;
  for (const item of items) {
    const index = getAttrIndex(item.attr);
    if (index !== currentIndex) {
      groups.push([]);
      currentIndex = index;
    }
    groups[groups.length - 1].push(item);
  }
  return groups;
};
var PaymentDetails = ({ items, title }) => {
  const groups = groupItemsByTransaction(items);
  return /* @__PURE__ */ jsxs29("section", { className: "border-semantic-global-border-light p-semantic-global-md bg-semantic-global-background-white flex w-full flex-col border", children: [
    /* @__PURE__ */ jsx37("h3", { "data-e2e": "headline-payment", className: "typography-heading-sm text-semantic-global-text-default mb-semantic-global-md", children: title }),
    /* @__PURE__ */ jsx37("div", { className: "gap-semantic-global-md flex flex-col", children: groups.map((group, groupIndex) => /* @__PURE__ */ jsxs29(React2.Fragment, { children: [
      groupIndex > 0 ? /* @__PURE__ */ jsx37(Seperator, {}) : null,
      /* @__PURE__ */ jsx37("div", { className: "gap-semantic-global-xs flex flex-col", children: group.map((item, itemIndex) => /* @__PURE__ */ jsxs29("div", { className: "gap-semantic-global-2xs flex flex-row", children: [
        /* @__PURE__ */ jsxs29("span", { className: "typography-body-md-regular text-semantic-global-text-default", children: [
          item.label ? `${item.label}: ` : "",
          " "
        ] }),
        item.price && item.currency ? /* @__PURE__ */ jsx37("span", { "data-e2e": item.attr, className: "typography-body-md-regular text-semantic-global-text-default", children: /* @__PURE__ */ jsx37(Price, { price: item.price, currency: item.currency }) }) : /* @__PURE__ */ jsx37("span", { "data-e2e": item.attr, className: "typography-body-md-regular text-semantic-global-text-default", children: item.value })
      ] }, itemIndex)) })
    ] }, groupIndex)) })
  ] });
};

// src/components/confirmation/section-wrapper/SectionWrapper.tsx
import { clsx as clsx22 } from "clsx";
import { EditIcon } from "@dfds-frontend/navigator-icons/icons";
import { ferryUrls } from "@dfds-pax/utils";
import { jsx as jsx38, jsxs as jsxs30 } from "react/jsx-runtime";
var SectionWrapper = ({ area, children, locale, reservationNo, showEditButtons, t }) => {
  var _a;
  let editUrl = "#";
  if (showEditButtons && locale && reservationNo && area !== "PETS") {
    const ferrySlug = ((_a = ferryUrls.find((url) => url.locales.includes(locale || "en-gb"))) == null ? void 0 : _a.ferry) || "ferries-passagers";
    editUrl = `/${locale}/${ferrySlug}/mybooking/${reservationNo}/edit/${area.toLowerCase()}`;
  }
  return /* @__PURE__ */ jsxs30("div", { className: "border-semantic-global-border-light md:border", children: [
    /* @__PURE__ */ jsxs30(
      "div",
      {
        className: clsx22(
          "md:bg-semantic-global-background-white md:py-semantic-global-lg pb-semantic-global-lg px-semantic-global-md border-semantic-global-border-light flex flex-col md:flex-row md:border-b",
          !showEditButtons && "md:pb-semantic-global-sm md:px-semantic-global-xs md:border-b-0"
        ),
        children: [
          /* @__PURE__ */ jsx38(
            "h3",
            {
              "data-e2e": "pets-section-header",
              className: "typography-heading-lg md:typography-heading-md md:px-semantic-global-md mt-semantic-global-xs text-semantic-global-text-default",
              children: t(area)
            }
          ),
          showEditButtons && area !== "PETS" ? /* @__PURE__ */ jsx38(
            LinkButton,
            {
              icon: /* @__PURE__ */ jsx38(EditIcon, {}),
              iconPosition: "right",
              href: editUrl,
              className: "mt-semantic-global-md w-full md:mt-0 md:ml-auto md:w-auto",
              children: t(`EDIT-${area === "OTHER-DETAILS" ? "VEHICLES" : area}`)
            }
          ) : null
        ]
      }
    ),
    /* @__PURE__ */ jsx38("section", { className: "px-semantic-global-md py-semantic-global-lg md:p-semantic-global-lg bg-semantic-global-background-white flex flex-col", children })
  ] });
};

// src/components/confirmation/vehicle-details/VehicleDetails.tsx
import { clsx as clsx23 } from "clsx";
import { jsx as jsx39, jsxs as jsxs31 } from "react/jsx-runtime";
var VehicleDetails = ({ vehicleDetails }) => {
  const { icon, items } = vehicleDetails;
  return /* @__PURE__ */ jsxs31("div", { className: "gap-semantic-global-xs flex flex-col", children: [
    icon,
    items.map((item, index) => /* @__PURE__ */ jsx39(VehicleItem, { attr: item.attr, label: item.label, showAsMediumText: item.showAsMediumText, showDots: true, value: item.value }, index))
  ] });
};
var VehicleItem = ({ attr, label, showAsMediumText, showDots, value }) => {
  return /* @__PURE__ */ jsxs31("div", { className: "flex flex-row justify-between", children: [
    /* @__PURE__ */ jsx39("span", { className: "typography-body-md-regular text-semantic-global-text-light", children: label }),
    showDots ? /* @__PURE__ */ jsx39(PriceDots, {}) : null,
    /* @__PURE__ */ jsx39(
      "span",
      {
        "data-e2e": attr,
        className: clsx23(
          `text-semantic-global-text-default ml-auto`,
          showAsMediumText ? "typography-body-md-medium" : "typography-body-md-regular"
        ),
        children: value
      }
    )
  ] });
};

// src/components/confirmation/booking-confirmation/BookingConfirmation.tsx
import { Fragment as Fragment6, jsx as jsx40, jsxs as jsxs32 } from "react/jsx-runtime";
var getDepartureTitle = (index) => {
  if (index === 0) return "OUTBOUND";
  if (index === 1) return "RETURN";
  return `DEPARTURE ${index + 1}`;
};
var arePassengersIdentical = (departures, isSog) => {
  if (departures.length <= 1) return true;
  const firstPassengers = [...departures[0].passengerList].sort((a, b) => a.firstname.localeCompare(b.firstname));
  return departures.slice(1).every((departure) => {
    const departurePassengers = [...departure.passengerList].sort((a, b) => a.firstname.localeCompare(b.firstname));
    if (departurePassengers.length !== firstPassengers.length) return false;
    return departurePassengers.every((passenger, index) => {
      const firstPassenger = firstPassengers[index];
      const isSamePassenger = passenger.firstname === firstPassenger.firstname && passenger.lastname === firstPassenger.lastname;
      if (!isSamePassenger) return false;
      return isSog ? passenger.couponNumber === firstPassenger.couponNumber : true;
    });
  });
};
var summarizePriceItems = (priceItems) => {
  var _a;
  if (!priceItems || priceItems.length === 0) return void 0;
  const totalQuantity = priceItems.reduce((sum, item) => sum + item.quantity, 0);
  const totalAmount = priceItems.reduce((sum, item) => sum + item.price.amount, 0);
  const currency = (_a = priceItems[0]) == null ? void 0 : _a.price.currency;
  if (!currency) return void 0;
  return {
    price: {
      amount: totalAmount,
      currency
    },
    quantity: totalQuantity
  };
};
var getProductInfo = (departure) => {
  const productItem = departure.productPriceItems.find((item) => item.itemCode === departure.productCode);
  const productCode = productItem ? productItem.itemCode : departure.productCode;
  return { isPaxObProduct: PaxObProducts.includes(productCode), productCode };
};
var renderDepartureSection = (bookingDetails, t, showOnMap, emissionsSurchargeTooltip, locale) => {
  var _a, _b, _c, _d, _e, _f;
  if (bookingDetails.departures.length === 0) return null;
  const outboundProductInfo = getProductInfo(bookingDetails.departures[0]);
  const returnProductInfo = bookingDetails.departures.length > 1 ? getProductInfo(bookingDetails.departures[1]) : void 0;
  return /* @__PURE__ */ jsxs32(Fragment6, { children: [
    /* @__PURE__ */ jsx40("div", { className: "gap-semantic-global-lg flex flex-col md:flex-row", children: bookingDetails.departures.map((departure, index) => {
      var _a2, _b2, _c2, _d2;
      const passengerSummary = summarizePriceItems(departure.passengerPriceItems);
      const vehicleSummary = summarizePriceItems(departure.vehiclePriceItems);
      const { isPaxObProduct, productCode } = getProductInfo(departure);
      return /* @__PURE__ */ jsxs32(
        "div",
        {
          className: "flex flex-1 flex-col items-center",
          children: [
            /* @__PURE__ */ jsxs32("div", { className: "mb-semantic-global-lg flex w-full flex-row items-center md:mb-0", children: [
              /* @__PURE__ */ jsxs32("h3", { className: "typography-heading-sm text-semantic-global-text-default md:hidden", children: [
                t(getDepartureTitle(index)),
                " "
              ] }),
              showOnMap ? /* @__PURE__ */ jsx40("span", { className: "ml-auto md:hidden", children: /* @__PURE__ */ jsx40(ShowOnMap, { title: t("SHOW-ON-MAP"), portUnlocode: departure.departurePort.unlocode }) }) : null
            ] }),
            /* @__PURE__ */ jsxs32(
              LegCard,
              {
                cardDetails: {
                  badgeText: isPaxObProduct ? t(`${productCode}-TICKET`) : t("TICKET"),
                  returnLeg: index > 0,
                  showBothWaysIcon: false,
                  showShipLegIcon: true
                },
                routeDetails: {
                  outboundRoute: t(departure.departurePort.unlocode),
                  outboundTime: departure.departureTimeLocal,
                  returnRoute: t(departure.arrivalPort.unlocode),
                  returnTime: departure.arrivalTimeLocal
                },
                terminalDetails: showOnMap ? {
                  portUnlocode: departure.departurePort.unlocode,
                  resource: t("SHOW-ON-MAP")
                } : void 0,
                timeDetails: { date: formatDepartureDate(departure.departureDateLocal, locale), legTitle: t(getDepartureTitle(index)) },
                children: [
                  /* @__PURE__ */ jsx40(LegCardItem, { showDots: true, text: `${t("ARRIVAL-TIME")}`, value: departure.arrivalTimeLocal }),
                  !bookingDetails.suppressPriceOnItinerary && ((_a2 = departure.productPriceItems[0]) == null ? void 0 : _a2.price) ? /* @__PURE__ */ jsx40(LegCardItem, { showDots: true, attr: "price-item", text: t("PRICE-LABEL"), price: departure.productPriceItems[0].price }) : null,
                  !bookingDetails.suppressPriceOnItinerary && passengerSummary ? /* @__PURE__ */ jsx40(
                    LegCardItem,
                    {
                      showDots: true,
                      attr: "passenger-price-item",
                      text: `${passengerSummary.quantity} x ${t("PASSENGER")}`,
                      price: passengerSummary.price
                    }
                  ) : null,
                  !bookingDetails.suppressPriceOnItinerary && vehicleSummary ? /* @__PURE__ */ jsx40(
                    LegCardItem,
                    {
                      showDots: true,
                      attr: "vehicle-price-item",
                      text: `${vehicleSummary.quantity} x ${t("VEHICLE")}`,
                      price: vehicleSummary.price
                    }
                  ) : null,
                  !bookingDetails.suppressPriceOnItinerary && (passengerSummary || vehicleSummary) ? /* @__PURE__ */ jsx40(
                    LegCardItem,
                    {
                      showDots: true,
                      attr: "total-price-item",
                      text: t("TOTAL"),
                      price: {
                        amount: ((_b2 = passengerSummary == null ? void 0 : passengerSummary.price.amount) != null ? _b2 : 0) + ((_c2 = vehicleSummary == null ? void 0 : vehicleSummary.price.amount) != null ? _c2 : 0),
                        currency: (passengerSummary != null ? passengerSummary : vehicleSummary).price.currency
                      }
                    }
                  ) : null,
                  /* @__PURE__ */ jsx40("div", { className: clsx24("", ((_d2 = departure == null ? void 0 : departure.unmappedPriceItems) == null ? void 0 : _d2.length) > 0 ? "mt-semantic-global-md" : ""), children: departure.unmappedPriceItems.map((item) => /* @__PURE__ */ jsx40(LegCardItem, { showDots: true, attr: "unmapped-price-item", text: t(item.itemCode), price: item.price }, item.itemCode)) })
                ]
              }
            )
          ]
        },
        `${departure.departurePort.unlocode}-${departure.arrivalPort.unlocode}-${index}`
      );
    }) }),
    /* @__PURE__ */ jsxs32(
      "div",
      {
        className: clsx24(
          "gap-semantic-global-xs flex flex-col",
          bookingDetails.emissionsSurcharge && !bookingDetails.suppressPriceOnItinerary || bookingDetails.bookingFees && bookingDetails.bookingFees.length > 0 || ((_a = bookingDetails == null ? void 0 : bookingDetails.offer) == null ? void 0 : _a.code) && ((_c = (_b = bookingDetails.offer) == null ? void 0 : _b.totalDiscount) == null ? void 0 : _c.amount) ? "mt-semantic-global-lg" : ""
        ),
        children: [
          bookingDetails.emissionsSurcharge && !bookingDetails.suppressPriceOnItinerary ? /* @__PURE__ */ jsxs32("div", { className: "flex items-center justify-between", children: [
            emissionsSurchargeTooltip,
            /* @__PURE__ */ jsx40("span", { className: "typography-body-md-regular text-semantic-global-text-default", children: /* @__PURE__ */ jsx40(Price, { price: bookingDetails.emissionsSurcharge.price.amount, currency: bookingDetails.emissionsSurcharge.price.currency }) })
          ] }) : null,
          !bookingDetails.suppressPriceOnItinerary ? (_d = bookingDetails.bookingFees) == null ? void 0 : _d.map((fee) => /* @__PURE__ */ jsxs32(
            "div",
            {
              className: "typography-body-md-regular text-semantic-global-text-default flex items-center justify-between",
              children: [
                /* @__PURE__ */ jsx40("span", { children: t(fee.itemCode) }),
                /* @__PURE__ */ jsx40("span", { children: /* @__PURE__ */ jsx40(Price, { price: fee.price.amount, currency: fee.price.currency }) })
              ]
            },
            `${fee.itemCode}-${fee.price.amount}`
          )) : null,
          !outboundProductInfo.isPaxObProduct ? /* @__PURE__ */ jsx40("div", { className: "typography-body-md-regular mt-semantic-global-lg text-semantic-global-text-default", children: /* @__PURE__ */ jsx40(MarkDown, { children: (_f = t((_e = outboundProductInfo.productCode) != null ? _e : returnProductInfo == null ? void 0 : returnProductInfo.productCode)) != null ? _f : "" }) }) : null
        ]
      }
    )
  ] });
};
var renderExtrasSection = (bookingDetails, t) => {
  const hasExtras = bookingDetails.extras.some((leg) => leg.length > 0);
  if (!hasExtras) return null;
  const renderExtraItems = (legExtras) => legExtras.map((extra) => /* @__PURE__ */ jsx40(
    LegCardPriceItem,
    {
      attr: "extras-card-item",
      showDots: true,
      hidePrice: bookingDetails.suppressPriceOnItinerary,
      text: `${extra.quantity} x ${t(extra.itemCode)}`,
      price: extra.price.amount,
      currency: extra.price.currency
    },
    `${extra.itemCode}-${extra.type}-${extra.quantity}`
  ));
  return /* @__PURE__ */ jsx40("div", { className: "gap-semantic-global-lg flex flex-col md:flex-row", children: bookingDetails.extras.map((legExtras, index) => {
    var _a;
    if (legExtras.length === 0) return null;
    return /* @__PURE__ */ jsxs32("div", { className: "flex-1", children: [
      /* @__PURE__ */ jsx40("h3", { className: "typography-heading-sm text-semantic-global-text-default mb-semantic-global-lg md:hidden", children: t(getDepartureTitle(index)) }),
      /* @__PURE__ */ jsx40(
        LegCard,
        {
          attr: `extras-card-${index > 0 ? "return" : "outbound"}`,
          cardDetails: {
            returnLeg: index > 0,
            showShipLegIcon: true,
            title: `${t(getDepartureTitle(index))} ${(_a = t("EXTRAS")) == null ? void 0 : _a.toLowerCase()}`
          },
          children: renderExtraItems(legExtras)
        },
        `extras-${index}`
      )
    ] }, `extras-${index}`);
  }) });
};
var renderPassengersSection = (bookingDetails, t) => {
  var _a;
  if (bookingDetails.departures.length === 0) return null;
  const formatSubsidyTypeLabel = (type) => type.replace(/([a-z])([A-Z])/g, "$1 $2");
  const firstPassengerThatHasMilitarySubsidyAppliedIndex = (_a = bookingDetails.departures[0].passengerSubsidyItems) == null ? void 0 : _a.findIndex(
    (item) => item.vehicleSubsidyApplied
  );
  const getSubsidyLabel = (type, index) => {
    const uppercaseWithDashes = type.replace(/([a-z])([A-Z])/g, "$1-$2").toUpperCase();
    const contentfulKey = `SUBSIDIES-${uppercaseWithDashes}`;
    const translated = t(contentfulKey);
    const baseLabel = translated === "KEY-MISSING" ? formatSubsidyTypeLabel(type) : translated;
    if (type === "Military" && index === firstPassengerThatHasMilitarySubsidyAppliedIndex) {
      return `${baseLabel} ${t("SUBSIDIES-MILITARY-VEHICLE-INCLUDED")}`;
    }
    return baseLabel;
  };
  const getPassengerSubsidyLegBreakdown = (passengerIndex, departureIndex) => {
    var _a2, _b, _c, _d, _e, _f;
    const outboundSubsidies = (_c = (_b = (_a2 = bookingDetails.departures[0]) == null ? void 0 : _a2.passengerSubsidyItems) == null ? void 0 : _b[passengerIndex]) == null ? void 0 : _c.subsidyAmounts;
    const returnSubsidies = (_f = (_e = (_d = bookingDetails.departures[1]) == null ? void 0 : _d.passengerSubsidyItems) == null ? void 0 : _e[passengerIndex]) == null ? void 0 : _f.subsidyAmounts;
    const subsidyLegBreakdown = [];
    if ((departureIndex === void 0 || departureIndex === 0) && (outboundSubsidies == null ? void 0 : outboundSubsidies.length)) {
      subsidyLegBreakdown.push({
        isReturnLeg: false,
        open: true,
        subsidyPrices: outboundSubsidies.map((subsidy) => ({
          amount: subsidy.amount > 0 ? -subsidy.amount : subsidy.amount,
          currency: bookingDetails.total.currency,
          label: getSubsidyLabel(subsidy.type, passengerIndex),
          showPriceDots: true
        })),
        title: `${t("OUTBOUND-SUBSIDIES")}`,
        titlesize: "sm"
      });
    }
    if ((departureIndex === void 0 || departureIndex === 1) && (returnSubsidies == null ? void 0 : returnSubsidies.length)) {
      subsidyLegBreakdown.push({
        isReturnLeg: true,
        open: true,
        subsidyPrices: returnSubsidies.map((subsidy) => ({
          amount: subsidy.amount > 0 ? -subsidy.amount : subsidy.amount,
          currency: bookingDetails.total.currency,
          label: getSubsidyLabel(subsidy.type, passengerIndex),
          showPriceDots: true
        })),
        title: `${t("RETURN-SUBSIDIES")}`,
        titlesize: "sm"
      });
    }
    return subsidyLegBreakdown;
  };
  const firstDeparture = bookingDetails.departures[0];
  const routeCode = mapUnloRoute(
    `${bookingDetails.departures[0].departurePort.unlocode}-${bookingDetails.departures[0].arrivalPort.unlocode}`
  );
  const isSog = sogRoutes.includes(routeCode);
  const passengersIdentical = arePassengersIdentical(bookingDetails.departures, isSog);
  if (passengersIdentical) {
    if (firstDeparture.passengerList.length === 0) return null;
    const passengers = firstDeparture.passengerList;
    return /* @__PURE__ */ jsxs32("div", { className: "gap-semantic-global-md md:gap-semantic-global-lg flex flex-col", children: [
      /* @__PURE__ */ jsx40(LegCard, { cardDetails: { showShipLegIcon: false, title: `${t("TOTAL-PASSENGERS")} (${firstDeparture.passengerList.length})` }, children: /* @__PURE__ */ jsx40(
        PassengersDetails,
        {
          categories: [
            { title: `${t("ADULTS")}: ${firstDeparture.passengersPerCategory.adults}`, type: "ADULT" },
            { title: `${t("CHILDREN")}: ${firstDeparture.passengersPerCategory.children}`, type: "CHILD" },
            { title: `${t("INFANTS")}: ${firstDeparture.passengersPerCategory.infants}`, type: "INFANT" }
          ]
        }
      ) }),
      /* @__PURE__ */ jsx40("div", { className: "gap-semantic-global-md md:gap-semantic-global-lg grid grid-cols-1 md:grid-cols-2", children: passengers.map((passenger, index) => {
        var _a2, _b;
        const subsidyLegBreakdown = isSog ? getPassengerSubsidyLegBreakdown(index) : [];
        return /* @__PURE__ */ jsx40(
          Passenger,
          {
            category: passenger.category ? t(passenger.category) : t("PASSENGER"),
            couponNumber: ((_a2 = bookingDetails.departures[0].passengerList[index]) == null ? void 0 : _a2.couponNumber) && ((_b = bookingDetails.departures[0].passengerList[index]) == null ? void 0 : _b.couponNumber.toLowerCase()) !== "n/a" ? { label: t("COUPON-NUMBER"), value: bookingDetails.departures[0].passengerList[index].couponNumber } : void 0,
            fullname: `${passenger.firstname} ${passenger.lastname}`,
            children: subsidyLegBreakdown.length > 0 ? /* @__PURE__ */ jsx40(SubsidyBreakdown, { subsidyLegBreakdown, suppressPrice: bookingDetails.suppressPriceOnItinerary }) : null
          },
          `${passenger.firstname}-${passenger.lastname}-${index}`
        );
      }) })
    ] });
  }
  const hasAnyPassengers = bookingDetails.departures.some((dep) => dep.passengerList.length > 0);
  if (!hasAnyPassengers) return null;
  return /* @__PURE__ */ jsx40("div", { className: "gap-semantic-global-lg flex flex-col", children: bookingDetails.departures.map((departure, departureIndex) => {
    if (departure.passengerList.length === 0) return null;
    const passengers = departure.passengerList;
    return /* @__PURE__ */ jsxs32("div", { className: "gap-semantic-global-md flex flex-col", children: [
      /* @__PURE__ */ jsx40(LegCard, { cardDetails: { showShipLegIcon: false, title: `${t(getDepartureTitle(departureIndex))}` }, children: /* @__PURE__ */ jsx40(
        PassengersDetails,
        {
          categories: [
            { title: `${t("ADULTS")}: ${departure.passengersPerCategory.adults}`, type: "ADULT" },
            { title: `${t("CHILDREN")}: ${departure.passengersPerCategory.children}`, type: "CHILD" },
            { title: `${t("INFANTS")}: ${departure.passengersPerCategory.infants}`, type: "INFANT" }
          ]
        }
      ) }),
      /* @__PURE__ */ jsx40("div", { className: "gap-semantic-global-sm grid grid-cols-1 md:grid-cols-2", children: passengers.map((passenger, index) => {
        var _a2, _b;
        const subsidyLegBreakdown = isSog ? getPassengerSubsidyLegBreakdown(index, departureIndex) : [];
        return /* @__PURE__ */ jsx40(
          Passenger,
          {
            category: t("PASSENGER"),
            couponNumber: ((_a2 = bookingDetails.departures[departureIndex].passengerList[index]) == null ? void 0 : _a2.couponNumber) && ((_b = bookingDetails.departures[departureIndex].passengerList[index]) == null ? void 0 : _b.couponNumber.toLowerCase()) !== "n/a" ? {
              label: t("COUPON-NUMBER"),
              value: bookingDetails.departures[departureIndex].passengerList[index].couponNumber
            } : void 0,
            fullname: `${passenger.firstname} ${passenger.lastname}`,
            children: subsidyLegBreakdown.length > 0 ? /* @__PURE__ */ jsx40(SubsidyBreakdown, { subsidyLegBreakdown, suppressPrice: bookingDetails.suppressPriceOnItinerary }) : null
          },
          `${passenger.firstname}-${passenger.lastname}-${departureIndex}-${index}`
        );
      }) })
    ] }, `passengers-${departureIndex}`);
  }) });
};
var renderPetsSection = (bookingDetails, t) => {
  const hasPets = bookingDetails.pets.some((leg) => leg.length > 0);
  if (!hasPets) return null;
  const renderPetItems = (legPets) => legPets.map((pet) => /* @__PURE__ */ jsx40(
    LegCardPriceItem,
    {
      showDots: true,
      text: `${pet.quantity} x ${t(pet.itemCode)}`,
      price: pet.price.amount,
      hidePrice: bookingDetails.suppressPriceOnItinerary,
      currency: pet.price.currency
    },
    `${pet.itemCode}-${pet.type}-${pet.quantity}`
  ));
  return /* @__PURE__ */ jsx40("div", { className: "gap-semantic-global-lg flex flex-col md:flex-row", children: bookingDetails.pets.map((legPets, index) => {
    var _a;
    if (legPets.length === 0) return null;
    return /* @__PURE__ */ jsxs32("div", { className: "flex-1", children: [
      /* @__PURE__ */ jsx40("h3", { className: "typography-heading-sm text-semantic-global-text-default mb-semantic-global-lg md:hidden", children: t(getDepartureTitle(index)) }),
      /* @__PURE__ */ jsx40(
        LegCard,
        {
          cardDetails: {
            returnLeg: index > 0,
            showShipLegIcon: true,
            title: `${t(getDepartureTitle(index))} ${(_a = t("PETS")) == null ? void 0 : _a.toLowerCase()}`
          },
          children: renderPetItems(legPets)
        },
        `pets-${index}`
      )
    ] }, `pets-${index}`);
  }) });
};
var areVehiclesIdentical = (departures) => {
  if (departures.length <= 1) return true;
  const firstVehicles = departures[0].vehicles;
  return departures.slice(1).every((departure) => {
    const vehicles = departure.vehicles;
    if (vehicles.length !== firstVehicles.length) return false;
    return vehicles.every((vehicle, index) => {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      const firstVehicle = firstVehicles[index];
      return vehicle.vehicleSpecification.typeCode === firstVehicle.vehicleSpecification.typeCode && vehicle.vehicleSpecification.registrationNumber.value === firstVehicle.vehicleSpecification.registrationNumber.value && vehicle.vehicleSpecification.dimensions.length === firstVehicle.vehicleSpecification.dimensions.length && vehicle.vehicleSpecification.dimensions.height === firstVehicle.vehicleSpecification.dimensions.height && ((_a = vehicle.trailerSpecification) == null ? void 0 : _a.typeCode) === ((_b = firstVehicle.trailerSpecification) == null ? void 0 : _b.typeCode) && ((_c = vehicle.trailerSpecification) == null ? void 0 : _c.registrationNumber.value) === ((_d = firstVehicle.trailerSpecification) == null ? void 0 : _d.registrationNumber.value) && ((_e = vehicle.trailerSpecification) == null ? void 0 : _e.dimensions.length) === ((_f = firstVehicle.trailerSpecification) == null ? void 0 : _f.dimensions.length) && ((_g = vehicle.trailerSpecification) == null ? void 0 : _g.dimensions.height) === ((_h = firstVehicle.trailerSpecification) == null ? void 0 : _h.dimensions.height);
    });
  });
};
var renderCheckoutSection = (bookingDetails, t) => {
  var _a, _b, _c, _d, _e, _f;
  const vehiclesByDeparture = bookingDetails.departures.map((departure) => departure.vehicles);
  const hasVehicles = vehiclesByDeparture.some((vehicles) => vehicles.length > 0);
  const vehiclesIdentical = areVehiclesIdentical(bookingDetails.departures);
  const paymentItems = ((_a = bookingDetails.payments) == null ? void 0 : _a.reduce((items, payment, index) => {
    var _a2, _b2;
    if (payment.transactionType) {
      items.push({
        attr: `transaction-type-${index}`,
        label: t("TRANSACTION-TYPE"),
        value: payment.transactionType
      });
    }
    if (payment.paymentTypeCategory === "CARD" && payment.cardDetails) {
      if (payment.paymentType) {
        items.push({
          attr: `card-info-${index}`,
          label: t("CARD-TYPE"),
          value: payment.paymentType
        });
      }
      if (payment.cardDetails.cardNrLastFourDigits) {
        items.push({
          attr: `card-no-${index}`,
          label: t("CARD-NO"),
          value: `**** **** **** ${payment.cardDetails.cardNrLastFourDigits}`
        });
      }
      if (payment.cardDetails.expiryMonth && payment.cardDetails.expiryYear) {
        items.push({
          attr: `card-expiry-date-${index}`,
          label: t("CARD-EXPIRY"),
          value: `${payment.cardDetails.expiryMonth}/${payment.cardDetails.expiryYear}`
        });
      }
    }
    if (((_a2 = payment.price) == null ? void 0 : _a2.amount) !== void 0 && ((_b2 = payment.price) == null ? void 0 : _b2.amount) !== null && payment.price.currency) {
      items.push({
        attr: `payment-amount-${index}`,
        currency: payment.price.currency,
        label: t("AMOUNT"),
        price: payment.price.amount
      });
    }
    if (payment.date) {
      items.push({
        attr: `payment-date-${index}`,
        label: t("PAYMENT-DATE"),
        value: payment.date.split("T")[0]
      });
    }
    if (payment.paymentType) {
      items.push({
        attr: `payment-type-${index}`,
        label: t("PAYMENT-TYPE"),
        value: payment.paymentType
      });
    }
    return items;
  }, [])) || [];
  if (!hasVehicles && !bookingDetails.customer && bookingDetails.payments && ((_b = bookingDetails.payments) == null ? void 0 : _b.length) > 0) return null;
  const renderVehicles = (vehicles) => /* @__PURE__ */ jsx40("div", { className: "gap-semantic-global-md flex flex-col", children: vehicles.map((vehicle, vehicleIndex) => /* @__PURE__ */ jsxs32(
    React3.Fragment,
    {
      children: [
        /* @__PURE__ */ jsx40(
          VehicleDetails,
          {
            vehicleDetails: {
              icon: (() => {
                const VehicleIcon = getVehicleIcon(vehicle.vehicleSpecification.typeCode);
                return /* @__PURE__ */ jsx40(VehicleIcon, { size: "lg" });
              })(),
              items: [
                {
                  attr: "vehicle-type",
                  label: t("VEHICLE-TYPE"),
                  showAsMediumText: true,
                  value: t(getVehicleResourceKey2(vehicle.vehicleSpecification.typeCode))
                },
                ...["BIKV", "BIKVRES"].includes(vehicle.vehicleSpecification.typeCode) ? [] : [
                  {
                    attr: "vehicle-registration",
                    label: t("REGISTRATION"),
                    value: vehicle.vehicleSpecification.registrationNumber.value || "-"
                  },
                  {
                    attr: "vehicle-dimensions",
                    label: t("DIMENSIONS"),
                    value: `< ${vehicle.vehicleSpecification.dimensions.length}m x < ${vehicle.vehicleSpecification.dimensions.height}m`
                  }
                ]
              ]
            }
          }
        ),
        (vehicle == null ? void 0 : vehicle.trailerSpecification) ? /* @__PURE__ */ jsx40(
          VehicleDetails,
          {
            vehicleDetails: {
              icon: (() => {
                const TrailerVehicleIcon = getVehicleIcon(vehicle.trailerSpecification.typeCode);
                return /* @__PURE__ */ jsx40(TrailerVehicleIcon, { size: "lg" });
              })(),
              items: [
                {
                  attr: "trailer-type",
                  label: t("VEHICLE-TYPE"),
                  showAsMediumText: true,
                  value: t(getVehicleResourceKey2(vehicle.trailerSpecification.typeCode))
                },
                {
                  attr: "trailer-registration",
                  label: t("REGISTRATION"),
                  value: vehicle.trailerSpecification.registrationNumber.value || "-"
                },
                {
                  attr: "trailer-dimensions",
                  label: t("DIMENSIONS"),
                  value: `< ${vehicle.trailerSpecification.dimensions.length}m x < ${vehicle.trailerSpecification.dimensions.height}m`
                }
              ]
            }
          }
        ) : null
      ]
    },
    `${vehicle.vehicleSpecification.typeCode}-${vehicle.vehicleSpecification.registrationNumber.value}-${vehicleIndex}`
  )) });
  return /* @__PURE__ */ jsxs32(Fragment6, { children: [
    hasVehicles ? /* @__PURE__ */ jsx40("div", { className: "gap-semantic-global-lg flex flex-col md:flex-row", children: vehiclesIdentical ? /* @__PURE__ */ jsx40(
      LegCard,
      {
        cardDetails: {
          showBothWaysIcon: false,
          showShipLegIcon: false,
          title: bookingDetails.departures.length === 1 ? `${t("OUTBOUND")} ${(_c = t("VEHICLE")) == null ? void 0 : _c.toLowerCase()}` : `${t("OUTBOUND")} & ${(_d = t("RETURN")) == null ? void 0 : _d.toLowerCase()} ${(_e = t("VEHICLE")) == null ? void 0 : _e.toLowerCase()}`
        },
        children: renderVehicles(vehiclesByDeparture[0])
      }
    ) : vehiclesByDeparture.map((vehicles, departureIndex) => {
      if (vehicles.length === 0) return null;
      return /* @__PURE__ */ jsx40(
        LegCard,
        {
          cardDetails: {
            returnLeg: departureIndex > 0,
            showShipLegIcon: true,
            title: `${t(getDepartureTitle(departureIndex))} ${t("VEHICLE").toLowerCase()}`
          },
          children: renderVehicles(vehicles)
        },
        `vehicles-${departureIndex}`
      );
    }) }) : null,
    /* @__PURE__ */ jsxs32("div", { className: clsx24("gap-semantic-global-lg flex w-full flex-col md:flex-row", hasVehicles && "mt-semantic-global-lg"), children: [
      /* @__PURE__ */ jsx40(
        BillingDetails,
        {
          title: t("BILLING-DETAILS"),
          fullname: {
            label: "",
            value: `${((_f = bookingDetails == null ? void 0 : bookingDetails.customer) == null ? void 0 : _f.title) ? `${t(`PASSENGER-${bookingDetails.customer.title}-TITLE`)} ` : ""}${bookingDetails.customer.firstname} ${bookingDetails.customer.lastname}`
          },
          phoneNumber: bookingDetails.customer.phoneNumber ? { label: t("PHONE-NUMBER"), value: bookingDetails.customer.phoneNumber } : void 0,
          email: bookingDetails.customer.email ? { label: t("EMAIL"), value: bookingDetails.customer.email } : void 0
        }
      ),
      paymentItems.length > 0 ? /* @__PURE__ */ jsx40(PaymentDetails, { title: t("PAYMENT-DETAILS"), items: paymentItems }) : null
    ] })
  ] });
};
var BookingConfirmation = (_a) => {
  var _b = _a, {
    _t,
    beforeBookingCompleted,
    bookingDetails,
    className,
    emissionsSurchargeTooltip,
    locale,
    showOnMap = false
  } = _b, props = __objRest(_b, [
    "_t",
    "beforeBookingCompleted",
    "bookingDetails",
    "className",
    "emissionsSurchargeTooltip",
    "locale",
    "showOnMap"
  ]);
  var _a2, _b2, _c;
  const t = (resource) => _t && resource ? _t(resource) : resource || "KEY-MISSING";
  const sectionContent = [
    { area: "DEPARTURES", content: renderDepartureSection(bookingDetails, t, showOnMap, emissionsSurchargeTooltip, locale) },
    { area: "PASSENGERS", content: renderPassengersSection(bookingDetails, t) },
    { area: "EXTRAS", content: renderExtrasSection(bookingDetails, t) },
    { area: "PETS", content: renderPetsSection(bookingDetails, t) },
    { area: "OTHER-DETAILS", content: renderCheckoutSection(bookingDetails, t) }
  ].filter((section) => section.content);
  const showEditButtons = bookingDetails.departures.some((departure) => {
    const routeCode = mapUnloRoute(`${departure.departurePort.unlocode}-${departure.arrivalPort.unlocode}`);
    return compoundRoutes.includes(routeCode) && bookingDetails.context === "CONFIRMATION-STEP";
  });
  return /* @__PURE__ */ jsxs32("div", __spreadProps(__spreadValues({ className: clsx24("gap-semantic-global-lg flex flex-col", className) }, props), { children: [
    sectionContent.map((section) => /* @__PURE__ */ jsx40(
      SectionWrapper,
      {
        area: section.area,
        t,
        showEditButtons,
        locale,
        reservationNo: bookingDetails.bookingReference,
        children: section.content
      },
      section.area
    )),
    !bookingDetails.suppressPriceOnItinerary ? /* @__PURE__ */ jsx40("div", { "data-e2e": "main-price-breakdown", className: clsx24({ hidden: bookingDetails.context !== "REVIEW-STEP" }), children: /* @__PURE__ */ jsx40(
      TotalPriceBreakdown,
      {
        mode: "sandy",
        total: bookingDetails.total.amount,
        currency: bookingDetails.total.currency,
        t,
        beforeBookingCompleted,
        paidAmount: (_a2 = bookingDetails.paidAmount) == null ? void 0 : _a2.amount,
        originalPrice: bookingDetails.originalTotalPrice.amount,
        subsidies: (_b2 = bookingDetails.subsidyAmount) == null ? void 0 : _b2.amount,
        creditsAvailable: bookingDetails.outstandingAmount.amount < 0 ? bookingDetails.outstandingAmount.amount : void 0,
        outstandingAmount: bookingDetails.outstandingAmount.amount > 0 ? bookingDetails.outstandingAmount.amount : void 0,
        residentVehicleDiscount: bookingDetails.residentVehicleDiscount,
        offer: bookingDetails.offer ? {
          displayText: bookingDetails.offer.description,
          hidePrice: bookingDetails.offer.hidePrice,
          isTracking: bookingDetails.offer.isTracking,
          price: (_c = bookingDetails.offer.totalDiscount) == null ? void 0 : _c.amount
        } : void 0
      }
    ) }) : null
  ] }));
};

// src/components/confirmation/booking-owner/BookingOwner.tsx
import { jsx as jsx41, jsxs as jsxs33 } from "react/jsx-runtime";
var BookingOwner = ({ country, email, fullname, phoneNumber, t }) => {
  return /* @__PURE__ */ jsxs33("section", { className: "border-semantic-global-border-light bg-semantic-global-background-white flex w-full min-w-0 flex-col md:border", children: [
    /* @__PURE__ */ jsx41("h2", { className: "typography-heading-md md:p-semantic-global-lg px-semantic-global-lg pt-semantic-global-lg text-semantic-global-text-default border-semantic-global-border-light md:border-b", children: t("BOOKING-OWNER") }),
    /* @__PURE__ */ jsxs33("div", { className: "p-semantic-global-lg gap-semantic-global-md flex flex-col items-start self-stretch", children: [
      /* @__PURE__ */ jsx41(LineItem, { label: t("NAME"), value: fullname }),
      email ? /* @__PURE__ */ jsx41(LineItem, { label: t("EMAIL"), value: email }) : null,
      phoneNumber ? /* @__PURE__ */ jsx41(LineItem, { label: t("PHONE-NUMBER"), value: phoneNumber }) : null,
      country ? /* @__PURE__ */ jsx41(LineItem, { label: t("COUNTRY"), value: country }) : null
    ] })
  ] });
};
var LineItem = ({ label, value }) => /* @__PURE__ */ jsxs33("div", { className: "gap-semantic-global-2xs flex w-full flex-row items-center justify-start", children: [
  /* @__PURE__ */ jsxs33("span", { className: "typography-body-md-regular text-semantic-global-text-light w-35 shrink-0", children: [
    label,
    ":"
  ] }),
  /* @__PURE__ */ jsx41("span", { className: "typography-body-md-regular text-semantic-global-text-default min-w-0 flex-1 truncate", children: value })
] });

// src/components/confirmation/customer-service/CustomerService.tsx
import { ArrowForwardIcon as ArrowForwardIcon2 } from "@dfds-frontend/navigator-icons/icons";
import { jsx as jsx42, jsxs as jsxs34 } from "react/jsx-runtime";
var CustomerService = ({ link, t }) => {
  return /* @__PURE__ */ jsxs34("section", { className: "border-semantic-global-border-light bg-semantic-global-background-white flex w-full flex-col md:border", children: [
    /* @__PURE__ */ jsx42("h2", { className: "typography-heading-md md:p-semantic-global-lg px-semantic-global-lg pt-semantic-global-lg text-semantic-global-text-default border-semantic-global-border-light md:border-b", children: t("NEED-HELP") }),
    /* @__PURE__ */ jsxs34("div", { className: "p-semantic-global-lg gap-semantic-global-lg flex flex-col", children: [
      /* @__PURE__ */ jsx42("p", { className: "typography-body-md text-semantic-global-text-default", children: t("CONTACT-INFORMATION-DESCRIPTION") }),
      /* @__PURE__ */ jsx42(
        LinkButton,
        {
          href: link,
          className: "gap-semantic-global-2xs mr-auto hidden w-full items-center no-underline md:flex md:w-fit",
          variant: "ghostPrimary",
          target: "_blank",
          icon: /* @__PURE__ */ jsx42(ArrowForwardIcon2, { size: "md" }),
          iconPosition: "right",
          children: t("GO-TO-HELP-CENTER")
        }
      )
    ] })
  ] });
};

// src/components/confirmation/booking-ready/BookingReady.tsx
import { EditIcon as EditIcon2 } from "@dfds-frontend/navigator-icons/icons";
import { Fragment as Fragment7, jsx as jsx43, jsxs as jsxs35 } from "react/jsx-runtime";
var BookingReady = ({
  bookingIsEditable,
  customerServiceUrl,
  ferry,
  locale,
  reservationNo,
  t,
  viewBookingButton
}) => {
  const myBookingPath = `/${locale}/${ferry}/mybooking/${reservationNo}/edit`;
  return /* @__PURE__ */ jsxs35(
    "section",
    {
      "data-e2e": "booking-ready",
      className: "bg-semantic-global-background-white md:border-semantic-global-border-light h-full w-full md:border",
      children: [
        /* @__PURE__ */ jsxs35("div", { className: "px-semantic-global-md md:px-semantic-global-lg py-semantic-global-md gap-semantic-global-md hidden flex-row md:flex", children: [
          /* @__PURE__ */ jsxs35("div", { className: "gap-semantic-global-md md:gap-semantic-global-xs hidden flex-col md:flex", children: [
            /* @__PURE__ */ jsx43("h2", { className: "md:typography-heading-md typography-heading-sm text-semantic-global-text-default", children: t("YOU-ARE-ALL-SET") }),
            /* @__PURE__ */ jsx43("div", { className: "typography-body-md text-semantic-global-text-light", children: t("YOU-ARE-ALL-SET-DESCRIPTION") })
          ] }),
          /* @__PURE__ */ jsx43("div", { className: "gap-semantic-global-md mb-auto hidden md:ml-auto md:flex", children: /* @__PURE__ */ jsx43("div", { className: "gap-semantic-global-sm flex flex-row md:ml-auto", children: viewBookingButton }) })
        ] }),
        bookingIsEditable ? /* @__PURE__ */ jsxs35(Fragment7, { children: [
          /* @__PURE__ */ jsxs35("div", { className: "px-semantic-global-md py-semantic-global-lg gap-semantic-global-md border-t-semantic-global-border-light hidden border-t md:flex md:flex-row", children: [
            /* @__PURE__ */ jsx43(
              LinkButton,
              {
                className: "w-full",
                variant: "secondary",
                icon: /* @__PURE__ */ jsx43(EditIcon2, {}),
                iconPosition: "right",
                href: `${myBookingPath}/departures`,
                children: t("DEPARTURES")
              }
            ),
            /* @__PURE__ */ jsx43(
              LinkButton,
              {
                className: "w-full",
                variant: "secondary",
                icon: /* @__PURE__ */ jsx43(EditIcon2, {}),
                iconPosition: "right",
                href: `${myBookingPath}/passengers`,
                children: t("PASSENGERS")
              }
            ),
            /* @__PURE__ */ jsx43(LinkButton, { className: "w-full", variant: "secondary", icon: /* @__PURE__ */ jsx43(EditIcon2, {}), iconPosition: "right", href: `${myBookingPath}/vehicles`, children: t("VEHICLES") }),
            /* @__PURE__ */ jsx43(LinkButton, { className: "w-full", variant: "secondary", icon: /* @__PURE__ */ jsx43(EditIcon2, {}), iconPosition: "right", href: `${myBookingPath}/extras`, children: t("EXTRAS") })
          ] }),
          /* @__PURE__ */ jsxs35("div", { className: "px-semantic-global-md pt-semantic-global-lg gap-semantic-global-md flex flex-col md:hidden", children: [
            /* @__PURE__ */ jsx43("div", { className: "w-full", children: viewBookingButton }),
            /* @__PURE__ */ jsx43(LinkButton, { className: "w-full", variant: "secondary", href: customerServiceUrl, target: "_blank", children: t("GO-TO-HELP-CENTER") })
          ] })
        ] }) : /* @__PURE__ */ jsx43("div", { className: "px-semantic-global-md flex md:hidden", children: /* @__PURE__ */ jsx43("div", { className: "w-full", children: viewBookingButton }) })
      ]
    }
  );
};

// src/components/confirmation/port-summary/PortSummary.tsx
import { clsx as clsx25 } from "clsx";
import { FerryOutboundIcon as FerryOutboundIcon2, FerryReturnIcon as FerryReturnIcon2, LocationPinIcon as LocationPinIcon2, TimeIcon } from "@dfds-frontend/navigator-icons/icons";
import { jsx as jsx44, jsxs as jsxs36 } from "react/jsx-runtime";
var PortSummary = ({
  checkInInformation,
  className,
  outboundPortInformation,
  returnPortInformation,
  title
}) => {
  return /* @__PURE__ */ jsxs36(
    "div",
    {
      className: clsx25(
        "border-semantic-global-border-light bg-semantic-global-background-white gap-semantic-global-lg flex w-full flex-col border",
        className
      ),
      children: [
        /* @__PURE__ */ jsxs36("div", { className: "gap-semantic-global-md p-semantic-global-md md:p-semantic-global-lg flex flex-row items-center pb-0!", children: [
          /* @__PURE__ */ jsx44(LocationPinIcon2, { size: "lg" }),
          /* @__PURE__ */ jsx44("h2", { className: "typography-heading-sm text-semantic-global-text-default", children: title })
        ] }),
        /* @__PURE__ */ jsxs36("div", { className: "p-semantic-global-md md:p-semantic-global-lg gap-semantic-global-lg flex flex-col pt-0!", children: [
          /* @__PURE__ */ jsx44(PortInformation, { returnLeg: false, portInformation: outboundPortInformation, label: "Outbound Port Information" }),
          returnPortInformation ? /* @__PURE__ */ jsx44(PortInformation, { returnLeg: true, portInformation: returnPortInformation, label: "Return Port Information" }) : null,
          checkInInformation ? /* @__PURE__ */ jsx44(CheckinInformation, { checkInInformation }) : null
        ] })
      ]
    }
  );
};
var PortInformation = ({
  label,
  portInformation,
  returnLeg
}) => {
  return /* @__PURE__ */ jsxs36("div", { className: "gap-semantic-global-xs flex flex-col", children: [
    /* @__PURE__ */ jsxs36("div", { className: "gap-semantic-global-xs flex flex-row items-center", children: [
      returnLeg ? /* @__PURE__ */ jsx44("div", { className: "flex flex-col", children: /* @__PURE__ */ jsx44("div", { className: "text-semantic-global-background-deep-blue", children: /* @__PURE__ */ jsx44(FerryReturnIcon2, { size: "lg" }) }) }) : /* @__PURE__ */ jsx44("div", { className: "flex flex-col", children: /* @__PURE__ */ jsx44(FerryOutboundIcon2, { size: "lg" }) }),
      /* @__PURE__ */ jsx44("label", { className: "typography-body-xs-regular text-semantic-global-text-default", children: label })
    ] }),
    /* @__PURE__ */ jsx44(
      "p",
      {
        "data-e2e": returnLeg ? "port-info-homebound" : "port-info-outbound",
        className: "typography-body-sm-regular text-semantic-global-text-default",
        children: portInformation.information
      }
    )
  ] });
};
var CheckinInformation = ({ checkInInformation }) => {
  return /* @__PURE__ */ jsxs36("div", { className: "gap-semantic-global-xs flex flex-col", children: [
    /* @__PURE__ */ jsxs36("div", { className: "gap-semantic-global-xs flex flex-row items-center", children: [
      /* @__PURE__ */ jsx44(TimeIcon, { size: "lg" }),
      /* @__PURE__ */ jsx44("label", { className: "typography-body-xs-regular text-semantic-global-text-default", children: checkInInformation.label })
    ] }),
    /* @__PURE__ */ jsx44("p", { className: "typography-body-sm-regular mb-semantic-global-xs text-semantic-global-text-default", children: checkInInformation.information }),
    /* @__PURE__ */ jsxs36(InlineNotification, { variant: "info", children: [
      /* @__PURE__ */ jsxs36("span", { className: "typography-body-sm-regular mr-semantic-global-2xs font-bold", children: [
        checkInInformation.importantResource,
        ":"
      ] }),
      /* @__PURE__ */ jsx44("span", { className: "typography-body-sm-regular", children: checkInInformation.description })
    ] })
  ] });
};
export {
  AppContent,
  AppHeader,
  AppMain,
  AppNav,
  BillingDetails,
  BookingConfirmation,
  BookingConfirmationHeader,
  BookingOwner,
  BookingReady,
  CustomerService,
  DesktopCard,
  LegCard,
  LegCardHeader,
  LegCardItem,
  LegCardPriceItem,
  MobileCard,
  Page,
  PageHeader,
  Passenger,
  Passengers,
  PassengersDetails,
  PaymentDetails,
  PortSummary,
  PriceDots,
  Route,
  Section,
  SectionWrapper,
  SubsidyBreakdown,
  TotalPriceBreakdown,
  Vehicle,
  VehicleDetails,
  VehicleItem
};
